import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { useLocation } from "react-router-dom";
import Select from 'react-select';
import load from "../../../assets/Images/loader.gif";
import * as api from "../../../api_function";
// import BusinessOppotunitySurveyForm from './BusinessOppotunitySurveyForm';
import * as wifiOptions from "../../../options_sets/WifiOptions"
import { FaPlus, FaEdit, FaTrash } from "react-icons/fa";
import { cache } from 'react';
import { components as RSComponents } from 'react-select'



const optionClientProfil = [
    // { label: "Select Option", value: "0" },
    { label: "Business", value: "111260000" },
    { label: "Leisure", value: "111260001" },
    { label: "International Tourist", value: "111260002" },
    { label: "Mixed", value: "111260003" },
];

const optionPropertyType = [
    // { label: "Select Option", value: "0" },
    { label: "Leased", value: "111260000" },
    { label: " Owned", value: "111260001" },
];

const optionSolutation = [
    { label: "Select Salutation", value: "0" },
    { label: "Mr.", value: "1" },
    { label: "Mrs.", value: "2" },
    { label: "Miss", value: "3" },
];

const optionTurnOver = [
    { label: "Select Option", value: "0" },
    { label: "Diamond (>250Cr)", value: "111260000" },
    { label: "Emerald (100Cr-250Cr)", value: "111260001" },
    { label: "Ruby (10Cr-100Cr)", value: "111260002" },
    { label: "Bronze (1Cr-10Cr)", value: "111260003" }
]

const optionCountry = [{ label: "India", value: "10001" }];

const optionState = [
    { name: "Select State", code: "" },
    { name: "Andhra Pradesh", code: "100009" },
    { name: "Jharkhand", code: "100030" },
    { name: "Bihar", code: "100021" },
    { name: "Delhi", code: "100004" },
    { name: "Gujarat", code: "100015" },
    { name: "Haryana", code: "100008" },
    { name: "Jammu and Kashmir", code: "100011" },
    { name: "Karnataka", code: "100007" },
    { name: "Kerala", code: "100012" },
    { name: "Madhya Pradesh", code: "100014" },
    { name: "Maharashtra", code: "100002" },
    { name: "Odisha", code: "100026" },
    { name: "Other*", code: "100017" },
    { name: "Punjab", code: "100025" },
    { name: "Rajasthan", code: "100010" },
    { name: "Tamil Nadu", code: "100003" },
    { name: "Telangana", code: "100023" },
    { name: "Uttar Pradesh", code: "100006" },
    { name: "Uttarakhand", code: "100016" },
    { name: "West Bengal", code: "100013" },
    { name: "Goa", code: "100028" },
];

const optionCustomerSeg = [
    { label: "Select Customer Segment", value: "0" },
    { label: "SDWAN", value: "111260004" },
    { label: "SMB", value: "111260000" },
    { label: "Media", value: "111260001" },
    { label: "LA", value: "111260002" },
    { label: "SP", value: "111260003" },
];

const firmtype = [
    { value: "0", label: "Select Firm Type" },
    { value: "1", label: "Proprietorship" },
    { value: "2", label: "Partnership" },
    { value: "3", label: "Pvt Ltd" },
    { value: "4", label: "Ltd" },
    { value: "5", label: "Trust" },
    { value: "6", label: "Individual" },
    { value: "7", label: "LLP" },
];

const media = [
    { label: "Fibre", value: "1" },
    { label: "RF", value: "2" },
]

const ExServiceProvider = [
    { label: "Select Service Provider 1", value: "0" },
    { label: "Jio", value: "111260000" },
    { label: "ACT Fibernet", value: "569480014" },
    { label: "N.A", value: "569480012" },
    { label: "Others", value: "569480013" },
    { label: "Airtel", value: "569480000" },
    { label: "Aircel", value: "569480002" },
    { label: "BSNL", value: "569480003" },
    { label: "Hathway", value: "569480004" },
    { label: "MTNL", value: "569480005" },
    { label: "Nextra", value: "569480006" },
    { label: "Reliance Communications", value: "569480007" },
    { label: "Sify", value: "569480008" },
    { label: "Tata Communications", value: "569480009" },
    { label: "Tata DOCOMO", value: "569480010" },
    { label: "Tikona Infinet", value: "569480011" },
    { label: "Vodafone", value: "569480001" },
]

const optionInterestedFirewall = [
    { label: "Select Option", value: "" },
    { label: "Yes", value: "1" },
    { label: "No", value: "2" }
];

const optionInterestedVPN = [
    { label: "Select Option", value: "" },
    { label: "Yes", value: true },
    { label: "No", value: false }
];

const optionInterestedManageWiFi = [
    { label: "Select Option", value: "" },
    { label: "Yes", value: "1" },
    { label: "No", value: "2" }
];



const userTypeOption = [

    { value: "111260000", label: "Base Plan" },
    { value: "111260001", label: "User 2" },
    { value: "111260002", label: "User 3" },
    { value: "111260003", label: "User 4" },
    { value: "111260004", label: "Visitor" },
    { value: "111260005", label: "Event" },
];







const optionQualify = [
    { label: "Competition", value: "Competition" },
    { label: "Existing Vendor", value: "Existing Vendor" },
    { label: "Unviable", value: "Unviable" },
    { label: "Budget", value: "Budget" },
    { label: "Pricing", value: "Pricing" },
    { label: "Feature", value: "Feature" },
    { label: "Delays - Internal", value: "Delays - Internal" },
    { label: "Temp Lost", value: "Temp Lost" },
    { label: "Need change", value: "Need change" },
    { label: "Other", value: "other" }
];

// Option sets for dropdowns
const commonAreaOptions = [
    { value: "111260000", label: "Yes" },
    { value: "111260001", label: "No" },
];

const elevatorOptions = [
    { value: "111260000", label: "Yes" },
    { value: "111260001", label: "No" },
];

// Options for the multi-select floors.
// The value here is the floor identifier; the actual coverage flag is determined dynamically.
const floorOptions = [
    { value: "Basement", label: "Basement Coverage Required" },
    { value: "Ground", label: "Ground Floor Coverage Required" },
    { value: "First", label: "First Floor Coverage Required" },
    { value: "Second", label: "Second Floor Coverage Required" },
    { value: "Third", label: "Third Floor Coverage Required" },
    { value: "Fourth", label: "Fourth Floor Coverage Required" },
    { value: "Fifth", label: "Fifth Floor Coverage Required" },
    { value: "Sixth", label: "Sixth Floor Coverage Required" },
    { value: "Seventh", label: "Seventh Floor Coverage Required" },
    { value: "Eighth", label: "Eighth Floor Coverage Required" },
    { value: "Ninth", label: "Ninth Floor Coverage Required" },
    { value: "Tenth", label: "Tenth Floor Coverage Required" },
    { value: "Other", label: "Any other Area/Floor Coverage Required" },
];





const contactDesignationOptions = [
    { value: "111260000", label: "Owner" },
    { value: "111260001", label: "Manager" },
    { value: "111260002", label: "CareTaker" },
    { value: "111260003", label: "Other" },
    { value: "111260004", label: "Admin Manager" },
    { value: "111260005", label: "IT / Network Manager" },
    { value: "111260006", label: "Receptionist" },
    { value: "111260007", label: "Manager" },
    { value: "111260008", label: "General Manager" },
    { value: "111260009", label: "Owner/Director" },
    { value: "111260010", label: "Sales" },
    { value: "111260011", label: "IT" },
    { value: "111260012", label: "Procurement" },
];

const roleOptions = [
    { value: "111260000", label: "KDM" },
    { value: "111260001", label: "Influencer" },
];

const existingInternetProviderOptions = [
    { value: "111260000", label: "Airtel" },
    { value: "111260001", label: "Jio" },
    { value: "111260002", label: "Tata" },
    { value: "111260003", label: "ACT" },
    { value: "111260004", label: "New Building" },
    { value: "111260005", label: "Others" },
    { value: "111260006", label: "Excitel" },
    { value: "111260007", label: "Triple Play" },
];

const existingInternetOutflowOptions = [
    { value: "111260000", label: "<5000" },
    { value: "111260001", label: "5001 - 10000" },
    { value: "111260002", label: "10001- 15000" },
    { value: "111260003", label: "15001 - 20000" },
    { value: "111260004", label: "20001 - 25000" },
    { value: "111260005", label: ">25000" },
    { value: "111260006", label: "New Building" },
    { value: "111260007", label: "Others" },
    { value: "111260008", label: "10001 - 20000" },
    { value: "111260009", label: ">20,000" },
    { value: "111260010", label: ">10,000" },
];



const spectraRelationshipOptions = [
    { value: "111260000", label: "Existing User" },
    { value: "111260001", label: "Past User" },
    { value: "111260002", label: "New" },
];
const currentInfraOptions = [
    { value: "111260000", label: "Broadband" },
    { value: "111260001", label: "Access Points" },
    { value: "111260002", label: "Others" },
];


const BusinessOpportunityForm = () => {
    const style = {
        control: (base) => ({
            ...base,
            border: 0,
            // Remove box shadow
            boxShadow: "none",
            backgroundColor: "transparent",
            color: "black",
        }),
    };
    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            // backgroundColor: "black",
            color: "white",
            // border: "none",
            boxShadow: state.isFocused ? "none" : provided.boxShadow,
            textAlign: "center",
        }),
        singleValue: (provided) => ({
            ...provided,
            color: "white",
        }),
        option: (provided, state) => ({
            ...provided,
            // backgroundColor: state.isFocused ? 'blue' : 'black',
            color: "black",
            textAlign: "center",
        }),
        multiValue: (base) => ({
            ...base,
            backgroundColor: '#f0f0f0',
            borderRadius: '4px',
        }),
        multiValueLabel: (base) => ({
            ...base,
            color: '#333',
        }),
    };
    const [loaders, setLoaders] = useState(false);
    const [meetingcounter, setmeetingcounter] = useState("");
    const [allPraposalData, setAllPraposalData] = useState([]);
    const [userType, setUserType] = useState("");
    const [speedPerUser, setSpeedPerUser] = useState("");
    const [planValidity, setPlanValidity] = useState("");
    const [loginMechanism, setLoginMechanism] = useState("");

    const [activeForm, setActiveForm] = useState("form1");
    const [loading, setLoading] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState("");
    const [selectedRelatedProduct, setSelectedRelatedProduct] = useState("");
    const [discountFlag, setDiscountFlag] = useState();

    const [productOptions, setProductOptions] = useState([]);
    const [relatedProductOptions, setRelatedProductOptions] = useState([]);
    const [getOTCProd, setOTCProd] = useState([]);
    const [getRCProd, setRCProd] = useState([]);
    const [selectedPriceList, setSelectedPriceList] = useState("");
    const [priceListOptions, setPriceListOptions] = useState([]);
    const [leadid, setleadid] = useState("");
    const [industrydropdetails, setindustrydropdetails] = useState([]);
    const [selectSociety, setSelectSociety] = useState("");
    const [selectedFirmType, setSelectedFirmType] = useState();
    const [selectIndustry, setSelectIndustry] = useState();


    const [isRedundancyLocked, setIsRedundancyLocked] = useState(false);
    const [selectGroup, setSelectGroup] = useState("");

    const [loader, setLoader] = useState(false);
    const [companyOptions, setCompanyOptions] = useState([]);
    const [groupOptions, setGroupOptions] = useState([]);
    const [selectedCompany, setSelectedCompany] = useState(null);
    const [selectedGroup, setSelectedGroup] = useState(null);
    const [getOtcDiscount, setOtcDiscount] = useState([]);
    const [getRcDiscount, setRcDiscount] = useState([]);

    const [relationshipOptions, setRelationshipOptions] = useState([]);
    const [selectRelationship, setSelectRelationship] = useState("");
    const [relationShipId, setRelationShipId] = useState("");
    const [selectSolutaton, setSelectSolutaton] = useState(optionSolutation[0]);
    const [statusCode, setStatusCode] = useState("")
    const [status, setStatus] = useState("")
    const [selectCountry, setSelectCountry] = useState("");
    const [selectState, setSelectState] = useState("");
    const [selectCity, setSelectCity] = useState("");
    const [cityType, setCityType] = useState([]);
    const [areaList, setAreaList] = useState([]);
    const [selectArea, setSelectArea] = useState("");
    const [buildingList, setBuildingList] = useState([]);
    const [selectBuilding, setSelectBuilding] = useState("");
    const [selectCustomerSeg, setSelectCustomerSeg] = useState(optionCustomerSeg[0]);
    const [selectTurnOver, setSelectTurnOver] = useState(optionTurnOver[0]);
    const [selectedMedia, setSelectedMedia] = useState(optionTurnOver[0]);
    const [selectExServiceProvider1, setSelectExServiceProvider1] = useState();
    const [selectInterestedFirewall, setSelectInterestedFirewall] = useState('');
    const [selectInterestedVPN, setSelectInteretedVPN] = useState();
    const [selectInterestedManageWiFi, setSelectInterestedManageWiFi] = useState('');
    const [otcAmount, setOtcAmount] = useState("")
    const [rcAmount, setRcAmount] = useState("")

    const [getDoaApprovalData, setDoaApprovalData] = useState([]);

    const [getFeasibilityData, setFeasibilityData] = useState([]);
    const [getSurveyTaskData, setSurveyTaskData] = useState([]);
    const [getPreSalesTask, setPreSalesTask] = useState([]);

    const [getQuoteDetail, setQuoteDetail] = useState([]);

    const [getUserlicencegridData, setUserlicencegridData] = useState([]);
    const [allQuoteData, setAllQuoteData] = useState([]);
    const [proposalOptionType, setProposalOptionType] = useState("");
    const [showForm, setShowForm] = useState(false)
    const [selectedReasons, setSelectedReasons] = useState([])
    const [otherText, setOtherText] = useState("")
    const [totalFloors, setTotalFloors] = useState("");
    const [commonArea, setCommonArea] = useState(null);
    const [elevator, setElevator] = useState(null);
    // For multi-select, we keep the selected options
    const [selectedFloors, setSelectedFloors] = useState([]);
    const [proposalCounter, setProposalCounter] = useState("");


    // Initial floor coverage state: default is "111260001" (No) for every floor
    const initialFloorCoverage = {
        Basement: "111260001",
        Ground: "111260001",
        First: "111260001",
        Second: "111260001",
        Third: "111260001",
        Fourth: "111260001",
        Fifth: "111260001",
        Sixth: "111260001",
        Seventh: "111260001",
        Eighth: "111260001",
        Ninth: "111260001",
        Tenth: "111260001",
        Other: "111260001",
    };

    // State to hold the coverage flag for each floor
    const [floorCoverage, setFloorCoverage] = useState(initialFloorCoverage);

    // States for floor-specific room/bed details
    const [basementRooms, setBasementRooms] = useState("");
    const [basementBeds, setBasementBeds] = useState("");
    const [groundRooms, setGroundRooms] = useState("");
    const [groundBeds, setGroundBeds] = useState("");
    const [firstRooms, setFirstRooms] = useState("");
    const [firstBeds, setFirstBeds] = useState("");
    const [secondRooms, setSecondRooms] = useState("");
    const [secondBeds, setSecondBeds] = useState("");
    const [thirdRooms, setThirdRooms] = useState("");
    const [thirdBeds, setThirdBeds] = useState("");
    const [fourthRooms, setFourthRooms] = useState("");
    const [fourthBeds, setFourthBeds] = useState("");
    const [fifthRooms, setFifthRooms] = useState("");
    const [fifthBeds, setFifthBeds] = useState("");
    const [sixthRooms, setSixthRooms] = useState("");
    const [sixthBeds, setSixthBeds] = useState("");
    const [seventhRooms, setSeventhRooms] = useState("");
    const [seventhBeds, setSeventhBeds] = useState("");
    const [eighthRooms, setEighthRooms] = useState("");
    const [eighthBeds, setEighthBeds] = useState("");
    const [ninthRooms, setNinthRooms] = useState("");
    const [ninthBeds, setNinthBeds] = useState("");
    const [tenthRooms, setTenthRooms] = useState("");
    const [tenthBeds, setTenthBeds] = useState("");
    const [otherRooms, setOtherRooms] = useState("");
    const [otherBeds, setOtherBeds] = useState("");





    const [selectClientProfile, setSelectClientProfile] = useState("");
    const [selectPropertyType, setSelectPropertyType] = useState("");
    const [barrier, setBarrier] = useState("");


    const redirectPriceCalPage = () => {
        if (opportunityData?.Status?.toLowerCase() === "won") {
            Swal.fire({
                icon: "warning",
                html: '<div style="font-size: 14px;">This opportunity is already marked as <b>Won</b> and cannot be edited.</div>',
                confirmButtonText:
                    '<span style="font-size: 14px;color:rgb(148,101,170);">OK</span>',
                confirmButtonColor: "white",
                customClass: {
                    popup: "custom-popup",
                    confirmButton: "custom-confirm-button",
                },
            });
            return; // prevent further execution
        }
        if (opportunityData?.Status?.toLowerCase() === "lost") {
            Swal.fire({
                icon: "warning",
                html: '<div style="font-size: 14px;">This opportunity is already marked as <b>Lost</b> and cannot be edited.</div>',
                confirmButtonText:
                    '<span style="font-size: 14px;color:rgb(148,101,170);">OK</span>',
                confirmButtonColor: "white",
                customClass: {
                    popup: "custom-popup",
                    confirmButton: "custom-confirm-button",
                },
            });
            return; // prevent further execution
        }

        if (selectedFirmType.value == "0") {
            toast.warning("Please Select Firm Type", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
        } else {
            Swal.fire({
                html: '<div style="font-size: 14px;">Unsaved changes will be lost. Do you want to proceed?</div>',
                showCancelButton: true,
                confirmButtonText:
                    '<span style="font-size: 14px;color:rgb(148,101,170);">YES</span>',
                cancelButtonText:
                    '<span style="font-size: 14px;color:rgb(148,101,170);">NO</span>',
                confirmButtonColor: "white",
                cancelButtonColor: "white",
                customClass: {
                    popup: "custom-popup",
                    confirmButton: "custom-confirm-button",
                    cancelButton: "custom-cancel-button",
                },
            }).then((result) => {
                if (result.isConfirmed) {
                    navigate(`/priceCalculatorHotel?OppId=${OppId}`);
                }
            });
        }

    }

    const handleSelectClientProfil = (selectClientProfil) => {
        setSelectClientProfile(selectClientProfil);
    };

    const handleSelectPropertyType = (selectPropertyType) => {
        setSelectPropertyType(selectPropertyType);
    };


    // Handler for multi-select change: update selectedFloors and floorCoverage mapping.
    const handleFloorSelectChange = (selected) => {
        setSelectedFloors(selected);
        // Start with all floors defaulting to "No" (111260001)
        const newCoverage = { ...initialFloorCoverage };
        if (selected && selected.length) {
            selected.forEach((item) => {
                // When a floor is selected, update its coverage value to "Yes" (111260000)
                newCoverage[item.value] = "111260000";
            });
        }
        setFloorCoverage(newCoverage);

        // Validate count against Number of Floors
        const desiredFloors = parseInt(opportunityData.numberOfFloors, 10);
        if (!isNaN(desiredFloors)) {
            const selectedCount = selected ? selected.length : 0;
            if (selectedCount !== desiredFloors) {
                toast.warning("Selected floors must be equal to Number of Floors", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
            }
        }
    };

    const [selectPGType, setSelectPGType] = useState(null);
    const [selectTenantType, setSelectTenantType] = useState(null);
    const [selectContactDesignation, setSelectContactDesignation] = useState(null);


    const [selectExistingInternetProvider, setSelectExistingInternetProvider] = useState(null);
    const handleSelectExistingInternetProvider = (selectedOption) => {
        setSelectExistingInternetProvider(selectedOption);
        setOpportunityData((prev) => ({
            ...prev,
            existingInternetProvider: selectedOption ? selectedOption.value : "",
        }));
    };

    // Existing Internet Outflow Per Month
    const [selectExistingInternetOutflow, setSelectExistingInternetOutflow] = useState(null);
    const handleSelectExistingInternetOutflow = (selectedOption) => {
        setSelectExistingInternetOutflow(selectedOption);
        setOpportunityData((prev) => ({
            ...prev,
            existingInternetOutflow: selectedOption ? selectedOption.value : "",
        }));
    };

    // Current Infra (using placeholder options; update as needed)
    const [selectCurrentInfra, setSelectCurrentInfra] = useState(null);

    const handleSelectCurrentInfra = (selectedOption) => {
        setSelectCurrentInfra(selectedOption);
        setOpportunityData((prev) => ({
            ...prev,
            currentInfra: selectedOption ? selectedOption.value : "",
        }));
    };

    // Pain Points (multi-select)
    const [selectPainPoints, setSelectPainPoints] = useState([]);
    const handleSelectPainPoints = (selectedOptions) => {
        setSelectPainPoints(selectedOptions);
        setOpportunityData((prev) => ({
            ...prev,
            painPoints: selectedOptions ? selectedOptions.map((option) => option.value) : [],
        }));
    };

    // Urgent Triggers
    const [selectUrgentTriggers, setSelectUrgentTriggers] = useState(null);
    const handleSelectUrgentTriggers = (selectedOption) => {
        setSelectUrgentTriggers(selectedOption);
        setOpportunityData((prev) => ({
            ...prev,
            urgentTriggers: selectedOption ? selectedOption.value : "",
        }));
    };

    // Spectra Relationship
    const [selectSpectraRelationship, setSelectSpectraRelationship] = useState(null);
    const handleSelectSpectraRelationship = (selectedOption) => {
        setSelectSpectraRelationship(selectedOption);
        setOpportunityData((prev) => ({
            ...prev,
            spectraRelationship: selectedOption ? selectedOption.value : "",
        }));
    };
    const paymentoptions = [
        { value: "111260000", label: "Advance" },
    ];

    // Role
    const [selectRole, setSelectRole] = useState(null);
    const handleSelectRole = (selectedOption) => {
        setSelectRole(selectedOption);
        setOpportunityData((prev) => ({
            ...prev,
            role: selectedOption ? selectedOption.value : "",
        }));
        // getLocation();

    };

    const handleSelectContactDesignation = (selectedOption) => {
        setSelectContactDesignation(selectedOption);
        setOpportunityData({
            ...opportunityData,
            contactDesignation: selectedOption ? selectedOption.value : "",
        });
    };

    // const handleCompanyChange = (selectedOption) => {
    //     setSelectedCompany(selectedOption);
    // };

    const handleSelectGroup = (selectGroup) => {
        // setGroupOptions(selectGroup);
        setSelectedGroup(selectGroup);
    };

    const handleSelectRelationship = (selectGroup) => {
        setSelectRelationship(selectGroup);
    };

    const handlePriceListChange = (selectOption) => {
        setSelectedPriceList(selectOption);
    };

    const handleSelectFirmType = (selectFirmType) => {
        setSelectedFirmType(selectFirmType);
    };

    const handleIndustryChnage = (selected) => {
        setSelectIndustry(selected);
    };

    const handleSelectSolutation = (selectSolutation) => {
        setSelectSolutaton(selectSolutation);
    };

    const handleSelectCountry = (selectOption) => {
        setSelectCountry(selectOption);
    };

    const handleSelectState = (selectOption) => {
        setSelectState(selectOption);
    };

    const handleSelectCustomerSeg = (selectCustomerSeg) => {
        setSelectCustomerSeg(selectCustomerSeg);
    };

    const handleSelectTurnOver = (selectTurnOver) => {
        setSelectTurnOver(selectTurnOver);
    };

    const handleSelectMedia = (selectMedia) => {
        setSelectedMedia(selectMedia);
    };

    const handleSelectServiceProvider1 = (exServiceProvider) => {
        setSelectExServiceProvider1(exServiceProvider);
    };

    const handleInterestedFirewall = (firewall) => {
        setSelectInterestedFirewall(firewall);
    }

    const handleInterestedVPN = (value) => {
        // console.log(value);

        setSelectInteretedVPN(value);
    }

    const handleInterestedManageWiFi = (value) => {
        setSelectInterestedManageWiFi(value);
    }

    const yyyymmddFormat = (dateStr) => {
        if (!dateStr) return "";
        const parts = dateStr.split("-");
        if (parts.length !== 3) return "";
        if (parts[0].length === 4) {
            return dateStr; // Already in YYYY-MM-DD format
        } else {
            // Convert from DD-MM-YYYY to YYYY-MM-DD
            return `${parts[2]}-${parts[1]}-${parts[0]}`;
        }
    };

    const [minPoNext, setMinPoNext] = useState();

    const [opportunityData, setOpportunityData] = useState({
        ssId : "",
        Topic: "",
        OppId: "",
        OppStatus: "",
        leadname: "",
        OriginatingLead: "",
        LeadId: "",
        ContactPerson: "",
        Emailaddress: "",
        Mobilephone: "",
        BuildingNo: "",
        Block: "",
        Floor: "",
        PostalCode: "",
        Companyname: "",
        Status: "",
        nameOfHotel: "",
        latitude: "",
        longitude: "",
        spectraRFS: "",
        numberOfRooms: "",
        leasePeriod: "",
        numberOfFloors: "",
        roomsPerFloor: "",
        roomRent: "",
        hotelInternetRatings: "",
        googleRatings: "",
        detailsofTVs: "",
        otherDesignation: "",
        otherExistingInternetOutflow: "",
        otherExistingInternetProvider: "",
        OtherCurrentInfra: "",
        PpOthers: "",
        commonAreaName: ""
    });



    const fetchCompanyData = async () => {
        try {
            setLoaders(true);
            const apiUrl = process.env.REACT_APP_API_URL;
            const requestBody = {
                Action: "getCompany",
                Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                companyId: "New Company",
                password: sessionStorage.getItem('password'),
                userName: sessionStorage.getItem('userName'),
            };

            const response = await fetch(apiUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(requestBody),
            });
            const data = await response.json();
            //console.log("conpany name :", data.Response.Data);
            if (data.Status === "Success" && data.StatusCode === "200") {
                // return data.Response.Data.map((company) => ({
                //   label: `${company.Company_Name} (${company.Company_ID})`,
                //   value: company.Company_ID,
                //   group: `${company.Group_Name} (${company.Group_ID})`,
                //   groupId: company.Group_ID,
                // }));
                return data.Response.Data.map((company) => ({
                    label: company.Company_Name,
                    value: company.Company_ID,
                    group: company.Group_Name,
                    groupId: company.Group_ID,
                }));
            } else {
                console.error("Error in API response:", data);
                return [];
            }
        } catch (error) {
            console.error("Error fetching company data:", error);
        } finally {
            setLoaders(false);
        }
        return [];
    };

    const fetchRelationshipData = async (companyId) => {
        try {
            const apiUrl = process.env.REACT_APP_API_URL;
            const requestBody = {
                Action: "getRelationship",
                Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                companyId: companyId,
                password: sessionStorage.getItem('password'),
                userName: sessionStorage.getItem('userName'),
            };
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(requestBody),
            });
            const data = await response.json();
            if (data.Status === "Success" && data.StatusCode === "200") {
                return data.Response.Data.map((relationship) => ({
                    label: relationship.Relationship_Name,
                    value: relationship.Relationship_ID,
                }));
            } else {
                console.error("Error in API response:", data);
                return [];
            }
        } catch (error) {
            console.error("Error fetching relationship data:", error);
        }
        return [];
    };

    useEffect(() => {
        const loadOptions = async () => {
            const options = await fetchCompanyData("");
            //   let defaultCompanyGroupObj = options?.find((company) => (company.label).includes(userLeadData.companyName || "New Company"));
            // console.log(options, defaultCompanyGroupObj);
            // console.log(userLeadData.companyName);



            // setSelectedCompany({
            //   value: defaultCompanyGroupObj?.value,
            //   label:defaultCompanyGroupObj?.label,
            // });

            // setSelectedGroup({
            //   value: defaultCompanyGroupObj?.groupId,
            //   label:defaultCompanyGroupObj?.group,
            // });

            //   if(relationshipOptions?.length > 0){
            //   let defaultRelationshipObj = relationshipOptions?.find((relationship) => relationship.value == userLeadDataRaw?.RelationshipId);
            //   setSelectRelationship(defaultRelationshipObj);
            // }

            setCompanyOptions(options);

        };
        loadOptions();
    }, []);



    useEffect(() => {
        // Update group options when selectedCompany changes
        if (selectedCompany) {
            setGroupOptions([
                { label: selectedCompany.group, value: selectedCompany.groupId },
            ]);
            // setLeadName(selectedCompany.label); // Automatically set leadName to the selected company name
            //setCompanyId(selectedCompany.companyId); // Set the selected company ID
        } else {
            setGroupOptions([]);
            // setLeadName(""); // Reset leadName when no company is selected
            //setCompanyId(""); // Reset companyId when no company is selected
        }
    }, [selectedCompany]); // Only trigger the effect when selectedCompany changes

    useEffect(() => {
        const loadRelationships = async () => {
            if (selectedCompany) {
                const relationshipOptions = await fetchRelationshipData(
                    selectedCompany.value
                );
                setRelationshipOptions(relationshipOptions);
                // console.log(relationshipOptions);

                // setSelectRelationship(relationshipOptions.find((relation) => relation.value == relationShipId))
            }
        };
        loadRelationships();
    }, [selectedCompany]);

    const handleCompanyChange = (selectedOption) => {
        // console.log("selectedOption", selectedOption);
        setSelectedCompany(selectedOption);
        setSelectedGroup(null);
        setSelectRelationship(null)
        //setCompanyId(selectedOption ? selectedOption.value : "");
    };



    useEffect(() => {
        const fetchGetQuotation = async () => {
            try {
                // setLoading(true);
                const apiUrl = process.env.REACT_APP_API_URL;

                const requestData = {
                    "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    "Action": "getQuotation",
                    "OppId": OppId ? OppId : "",
                    "password": sessionStorage.getItem('password'),
                    "userName": sessionStorage.getItem('userName')
                }

                const response = await fetch(apiUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(requestData),
                });

                const result = await response.json();
                 if (Array.isArray(result?.Response?.Data) && result.Response.Data.length > 0) {
                    const option = result.Response.Data.find(item => item.OptionType) || result.Response.Data[0];
                    setProposalOptionType(option?.OptionType);
                }

                // console.log("API Response getQuotation:", result.Response.Data);
                setAllQuoteData(result?.Response?.Data)


            } catch (error) {
                console.error("Error fetching data:", error.message);
            } finally {
                // setLoading(false);
            }
        };

        fetchGetQuotation();
    }, []);

    const handleAddQuote = async () => {
        try {
            setLoading(true);
            const apiUrl = process.env.REACT_APP_API_URL;

            const requestData = {
                "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                "Action": "addQuotation",
                "OppId": OppId ? OppId : "",
                "password": sessionStorage.getItem('password'),
                "userName": sessionStorage.getItem('userName')
            }
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(requestData),
            });

            const result = await response.json();
            if (result?.Response?.StatusCode == 200) {
                toast.success(result?.Response?.Message, {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
                window.location.reload()
            }
        } catch (error) {
            console.error("Error fetching data:", error.message);
        } finally {
            setLoading(false);
        }
    }


    const handleWonQoute = async (quoteId) => {
        try {
            // setLoading(true);
            const apiUrl = process.env.REACT_APP_API_URL;
            const requestData =
            {
                "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                "Action": "updateQuote",
                "QuoteID": quoteId,
                "Status": "Won",
                "password": sessionStorage.getItem('password'),
                "userName": sessionStorage.getItem('userName'),
                "CreateRevisedQuote": "Yes"
            }

            const response = await fetch(apiUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(requestData),
            });

            const result = await response.json();
            if (result?.Response?.StatusCode == 200) {

                toast.success(result?.Response?.Message, {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
                window.location.reload()
            }
        } catch (error) {
            console.error("Error fetching data:", error.message);
        } finally {
            // setLoading(false);
        }
    }

    const handleLostQoute = async (quoteId) => {
        try {
            // setLoading(true);
            const apiUrl = process.env.REACT_APP_API_URL;

            const requestData = {
                "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                "Action": "updateQuote",
                "QuoteID": quoteId,
                "Status": "Lost",
                "password": sessionStorage.getItem('password'),
                "userName": sessionStorage.getItem('userName'),
                "CreateRevisedQuote": "Yes"
            }
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(requestData),
            });

            const result = await response.json();
            if (result?.Response?.StatusCode == 200) {
                toast.success(result?.Response?.Message, {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
                window.location.reload()
            }
        } catch (error) {
            console.error("Error fetching data:", error.message);
        } finally {
            // setLoading(false);
        }
    }


    const modalRef = useRef(null);
    useEffect(() => {
        const fetchGetPraposal = async () => {
            try {
                // setLoading(true);
                const apiUrl = process.env.REACT_APP_API_URL;

                const requestData = {
                    "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    "Action": "getProposalList",
                    "OpportunityID": OppId ? OppId : "",
                    "password": sessionStorage.getItem('password'),
                    "userName": sessionStorage.getItem('userName')
                }

                const response = await fetch(apiUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(requestData),
                });

                const result = await response.json();

                // console.log("API Response fetchGetPraposal:", result.Response.Data);
                setAllPraposalData(result?.Response?.Data)


            } catch (error) {
                console.error("Error fetching data:", error.message);
            } finally {
                // setLoading(false);
            }
        };

        fetchGetPraposal();
    }, []);

    // Function to convert a base64 string to a Blob
    const base64ToBlob = (base64, mime) => {
        const byteCharacters = atob(base64);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        return new Blob([byteArray], { type: mime });
    };

    const handleDownload = (data) => {
        // Ensure there is a base64 string available
        const base64String = data.ProposalFileContent;
        if (!base64String) {
            console.error("No base64 data available for download.");
            return;
        }

        // Set the file name and MIME type (adjust if needed)
        const fileName = data.ProposalDocName || "downloaded_document.pdf";
        const mimeType = "application/pdf"; // Change if your document type is different

        // Convert base64 string to a Blob object
        const blob = base64ToBlob(base64String, mimeType);

        // Create a URL for the Blob object
        const blobUrl = URL.createObjectURL(blob);

        // Create a temporary anchor element to trigger the download
        const downloadLink = document.createElement("a");
        downloadLink.href = blobUrl;
        downloadLink.download = fileName;

        // Append the link to the body (required for Firefox)
        document.body.appendChild(downloadLink);
        downloadLink.click();

        // Clean up and remove the temporary link
        document.body.removeChild(downloadLink);
        URL.revokeObjectURL(blobUrl);
    };
    useEffect(() => {
        const modalElement = modalRef.current;
        if (modalElement) {
            const handleShowModal = (event) => {
                // Button that triggered the modal
                const button = event.relatedTarget;
                // Extract info from data-bs-* attributes
                const recipient = button.getAttribute('data-bs-whatever');
                // Update the modal's content.
                const modalTitle = modalElement.querySelector('.modal-title');
                const modalBodyInput = modalElement.querySelector('.modal-body input');

                if (modalTitle) {
                    modalTitle.textContent = 'New message to ' + recipient;
                }
                if (modalBodyInput) {
                    modalBodyInput.value = recipient;
                }
            };

            modalElement.addEventListener('show.bs.modal', handleShowModal);

            // Cleanup the event listener when the component unmounts
            return () => {
                modalElement.removeEventListener('show.bs.modal', handleShowModal);
            };
        }
    }, []);
    const handleChange = (e) => {
        const { name, value, type } = e.target;

        // console.log(name, value);

        setOpportunityData((prevData) => ({
            ...prevData,
            [name]: type === "number" ? String(value) : value,
        }));

        if (name == "PoLock") {
            let minPoNext = new Date(new Date(value).setFullYear(new Date(value).getFullYear() + 1)).toISOString().split("T")[0]
            setMinPoNext(minPoNext)
            // console.log(PoNext); 
        }
    };



    const discountInput = async (e) => {
        const { name, value, type } = e.target;
        // console.log(name, value, getOTCProd[0], getRCProd[0]);

        // if(!selectedRelatedProduct?.value){
        //   toast.error("Select related product");
        //   return
        // }

        if (name == 'otcDiscount') {

            let req = { oppid: OppId, productid: getOTCProd[0].ProductId, discount: opportunityData.otcDiscount };
            const result = await api.updateOppProduct(req);
            // console.log(result);

        } else if (name == 'rcDiscount') {

            let req = { oppid: OppId, productid: getRCProd[0].ProductId, discount: opportunityData.rcDiscount };
            const result = await api.updateOppProduct(req);
            // console.log(result);

        } else if (name == 'OTCAmount') {
            if (otcAmount > (type === "number" ? String(value) : value)) {
                toast.warning("OTC Amount can't be less than the existing amount.");
                return;
            }
            // console.log(opportunityData.OTCAmount);

            let req = { oppid: OppId, productid: getOTCProd[0].ProductId, priceperunit: opportunityData.OTCAmount, pricing: "Override Price" };
            const result = await api.updateOppProduct(req);
            // console.log(result);

        } else if (name == 'RCAmount') {
            if (rcAmount > (type === "number" ? String(value) : value)) {
                toast.warning("RC Amount can't be less than the existing amount.");
                return;
            }

            let req = { oppid: OppId, productid: getRCProd[0].ProductId, priceperunit: opportunityData.RCAmount, pricing: "Override Price" };
            const result = await api.updateOppProduct(req);
            // console.log(result);

        }
    };


    const manageDocClickBusiness = () => {
        navigate(`/businessCAFmangeNewDoc?OppId=${OppId}`);
        // BusinessSAFmanageFormDOC() ;
    };


    const handleCreateCaf = () => {
        // console.log("leadid", leadid);

        navigate(`/businessCAFmanageForm?OppId=${OppId}&LeadId=${leadid}`)
    };



    const MultiValueRemove = (props) => (
        <RSComponents.MultiValueRemove {...props}>
            <span style={{ color: '#900', fontSize: '16px', lineHeight: '1' }}>×</span>
        </RSComponents.MultiValueRemove>
    )

    const handleChanged = (options) => {
        setSelectedReasons(options || [])
    }


    const handleLost = async () => {

        if (!selectedReasons.length) {
            toast.warning('Please pick at least one reason.')
            return
        }
        // If "Other" is selected, ensure user filled it in
        if (selectedReasons.some(r => r.value === "other") && !otherText.trim()) {
            toast.warning('Please specify the "Other" reason.');
            return;
        }
        // Build the comma-separated list, swapping in the user text for "other"
        const reasonList = selectedReasons
            .map(o => o.value === "other" ? otherText.trim() : o.label)
            .join(', ');
        // const reasonList = selectedReasons.map(o => o.label).join(', ')
        const apiUrl = process.env.REACT_APP_API_URL;
        const payload = {
            Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
            Action: 'opportunityDisqualify',           // ← your new API action
            userName: sessionStorage.getItem('userName'),
            password: sessionStorage.getItem('password'),
            OppID: OppId,                   // fixed key name
            ReasonForDisqualify: reasonList
        }

        try {
            const res = await fetch(apiUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
            })
            const data = await res.json()

            if (data.StatusCode === '200' || data.Response?.StatusCode === 200) {
                toast.success('Opportunity Lost successfully!', {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                })
                navigate('/businessOpportunityHotel')
            } else {
                toast.error(data.Response?.Message || data.Message || 'Failed to disqualify')
            }
        } catch (err) {
            console.error(err)
            toast.error('Network error, please try again.')
        }
    };







    const handleIconClick = (formId) => {
        // if (activeForm !== formId) {
        //   setActiveForm(formId);
        // }

        setActiveForm((prevActiveBox) =>
            prevActiveBox === formId ? null : formId
        );
    };
    const location = useLocation();

    const searchParams = new URLSearchParams(location.search);
    const OppId = searchParams.get("OppId");
    const CafId = searchParams.get("CafId");
    const navigate = useNavigate();
    // const redirectLeadPage = () => {
    //   navigate("/businessLead");
    // };

    useEffect(() => {
        const fetchData = async () => {
            const feasibilityData = await api.getFeasibility(OppId);
            const preSalesData = await api.getPreTask(OppId);
            const quoteData = await api.getQuote(OppId);
            const getApprovalData = await api.getApproval(OppId);
            const activeApproval = getApprovalData?.Response?.Data?.filter(approval => approval.Status == "Active")
            const sortedApproval = activeApproval?.sort((a, b) => parseInt(a.Name.split(" ")[0]) - parseInt(b.Name.split(" ")[0]));
            sortedApproval?.length > 0 && setDoaApprovalData(sortedApproval)

            feasibilityData?.Response?.Data?.length > 0 && setFeasibilityData(feasibilityData?.Response?.Data)
            preSalesData?.Response?.Data?.length > 0 && setPreSalesTask(preSalesData?.Response?.Data)
            setQuoteDetail(quoteData?.Response?.Data)

            const getSurveyTaskData = await api.getSurveyTask(OppId);
            const userlicencegrid = await api.getUserlicencegrid(OppId);
            // console.log(userlicencegrid);
            // console.log([getSurveyTaskData?.Response]);
            const allSurveyApproved = getSurveyTaskData?.Response?.Data?.every(approval => approval.Status === "Approved");
            // allSurveyApproved !== undefined && setSurveyApprovedFlag(allSurveyApproved);
            [getSurveyTaskData?.Response].length > 0 && setSurveyTaskData([getSurveyTaskData?.Response])


            if (userlicencegrid?.Status == "Success") {
                setUserlicencegridData(userlicencegrid?.Response?.userlicense)
            }
        };

        fetchData();
        // generateFeasibility();
        // createApproval();
        // createQuote();
        // Cleanup function not needed in this case
    }, []);


    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                const apiUrl = process.env.REACT_APP_API_URL;
                const requestBody = {
                    Action: "getopportunityHotel",
                    Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    LeadId: "",
                    OppId: OppId ? OppId : "",
                    password: sessionStorage.getItem('password'),
                    userName: sessionStorage.getItem('userName'),

                };
                const response = await fetch(apiUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(requestBody),
                });

                const responsedata = await response.json();
                const responseData = responsedata?.Response?.Data?.[0];
                // console.log(responseData?.ProductSegment, responseData?.Building_BuildingStatus, responseData?.Redunancy, responseData?.InfraFlag);

                // console.log("getLeads1" ,responsedata1);
                if (responsedata?.Status === "Success" && responseData) {
                    const pgInfo = responseData.PgInfo;
                    const hotelInfo = responseData.HotelInfo;
                    setmeetingcounter(pgInfo.MeetingCounter);
                    console.log("hotelInfo", hotelInfo);
                    setProposalCounter(pgInfo?.ProposalCounter);
                    setSelectSolutaton(optionSolutation.find(option => option.value === String(responseData.Salutation)) || null)

                    setSelectContactDesignation(contactDesignationOptions.find(option => option.value === pgInfo.Designation) || null);
                    setSelectRole(roleOptions.find(option => option.value === pgInfo.Role) || null);
                    setSelectExistingInternetProvider(
                        existingInternetProviderOptions.find(option => option.value === hotelInfo.ExistingInternetProvider) || null
                    );
                    setSelectExistingInternetOutflow(
                        existingInternetOutflowOptions.find(option => option.value === hotelInfo.ExistingInternetOutFlowPerMonth) || null
                    );
                    setSelectClientProfile(optionClientProfil.find(option => option.value === hotelInfo.ClientProfile) || null)
                    setSelectPropertyType(optionPropertyType.find(option => option.value === hotelInfo.TypeOfProperty) || null)
                    setBarrier(hotelInfo.Barriers);
                    // setSelectUrgentTriggers(
                    //     urgentTriggersOptions.find(option => option.value === pgInfo.UrgentTriggers) || null
                    // );
                    setSelectSpectraRelationship(
                        spectraRelationshipOptions.find(option => option.value === pgInfo.SpectraRelationship) || null
                    );
                    const currentInfraOption =
                        currentInfraOptions.find((opt) => opt.value === pgInfo.CurrentInfra) || null;
                    setSelectCurrentInfra(currentInfraOption);

                    setCommonArea(commonAreaOptions.find(item => item.value === pgInfo.CommonArea) || null);

                    // Update the floor coverage mapping (defaulting to "No" if not provided)
                    // console.log("pgInfo.BasementCoverageRequired",pgInfo.BasementCoverageRequired);

                    setFloorCoverage({
                        Basement: pgInfo.BasementCoverageRequired || "111260001",
                        Ground: pgInfo.GroundFloorCoverageRequired || "111260001",
                        First: pgInfo.FirstFloorCoverageRequired || "111260001",
                        Second: pgInfo.SecondFloorCoverageRequired || "111260001",
                        Third: pgInfo.ThirdFloorCoverageRequired || "111260001",
                        Fourth: pgInfo.FourthFloorCoverageRequired || "111260001",
                        Fifth: pgInfo.FifthFloorCoverageRequired || "111260001",
                        Sixth: pgInfo.SixthFloorCoverageRequired || "111260001",
                        Seventh: pgInfo.SeventhFloorCoverageRequired || "111260001",
                        Eighth: pgInfo.EighthFloorCoverageRequired || "111260001",
                        Ninth: pgInfo.NinthFloorCoverageRequired || "111260001",
                        Tenth: pgInfo.TenthFloorCoverageRequired || "111260001",
                        Other: pgInfo.AnyAreaFloorCoverageRequired || "111260001",
                    });

                    // Update floor-specific room and bed details
                    setBasementRooms(pgInfo.NoOfRoomsinBasement || "");
                    setBasementBeds(pgInfo.NoOfBedsInBasement || "");
                    setGroundRooms(pgInfo.NoOfRoomsinGroundFloor || "");
                    setGroundBeds(pgInfo.NoOfBedsInGroundFloor || "");
                    setFirstRooms(pgInfo.NoOfRoomsinFirstFloor || "");
                    setFirstBeds(pgInfo.NoOfBedsInFirstFloor || "");
                    setSecondRooms(pgInfo.NoOfRoomsinSecondFloor || "");
                    setSecondBeds(pgInfo.NoOfBedsInSecondFloor || "");
                    setThirdRooms(pgInfo.NoOfRoomsinThirdFloor || "");
                    setThirdBeds(pgInfo.NoOfBedsInThirdFloor || "");
                    setFourthRooms(pgInfo.NoOfRoomsinFourthFloor || "");
                    setFourthBeds(pgInfo.NoOfBedsInFourthFloor || "");
                    setFifthRooms(pgInfo.NoOfRoomsinFifthFloor || "");
                    setFifthBeds(pgInfo.NoOfBedsInFifthFloor || "");
                    setSixthRooms(pgInfo.NoOfRoomsinSixthFloor || "");
                    setSixthBeds(pgInfo.NoOfBedsInSixthFloor || "");
                    setSeventhRooms(pgInfo.NoOfRoomsinSeventhFloor || "");
                    setSeventhBeds(pgInfo.NoOfBedsInSeventhFloor || "");
                    setEighthRooms(pgInfo.NoOfRoomsinEighthFloor || "");
                    setEighthBeds(pgInfo.NoOfBedsInEightFloor || ""); // API field is "NoOfBedsInEightFloor"
                    setNinthRooms(pgInfo.NoOfRoomsinNinthFloor || "");
                    setNinthBeds(pgInfo.NoOfBedsInNinthFloor || "");
                    setTenthRooms(pgInfo.NoOfRoomsinTenthFloor || "");
                    setTenthBeds(pgInfo.NoOfBedsInTenthFloor || "");
                    setOtherRooms(pgInfo.NoOfRoomsinAnyotherAreaFloor || "");
                    setOtherBeds(pgInfo.NoOfBedsInAnyAreaFloor || "");


                    const selected = [];
                    if (pgInfo.BasementCoverageRequired === "111260000") {
                        selected.push(floorOptions.find(option => option.value === "Basement"));
                    }
                    if (pgInfo.GroundFloorCoverageRequired === "111260000") {
                        selected.push(floorOptions.find(option => option.value === "Ground"));
                    }
                    if (pgInfo.FirstFloorCoverageRequired === "111260000") {
                        selected.push(floorOptions.find(option => option.value === "First"));
                    }
                    if (pgInfo.SecondFloorCoverageRequired === "111260000") {
                        selected.push(floorOptions.find(option => option.value === "Second"));
                    }
                    if (pgInfo.ThirdFloorCoverageRequired === "111260000") {
                        selected.push(floorOptions.find(option => option.value === "Third"));
                    }
                    if (pgInfo.FourthFloorCoverageRequired === "111260000") {
                        selected.push(floorOptions.find(option => option.value === "Fourth"));
                    }
                    if (pgInfo.FifthFloorCoverageRequired === "111260000") {
                        selected.push(floorOptions.find(option => option.value === "Fifth"));
                    }
                    if (pgInfo.SixthFloorCoverageRequired === "111260000") {
                        selected.push(floorOptions.find(option => option.value === "Sixth"));
                    }
                    if (pgInfo.SeventhFloorCoverageRequired === "111260000") {
                        selected.push(floorOptions.find(option => option.value === "Seventh"));
                    }
                    if (pgInfo.EighthFloorCoverageRequired === "111260000") {
                        selected.push(floorOptions.find(option => option.value === "Eighth"));
                    }
                    if (pgInfo.NinthFloorCoverageRequired === "111260000") {
                        selected.push(floorOptions.find(option => option.value === "Ninth"));
                    }
                    if (pgInfo.TenthFloorCoverageRequired === "111260000") {
                        selected.push(floorOptions.find(option => option.value === "Tenth"));
                    }
                    if (pgInfo.AnyAreaFloorCoverageRequired === "111260000") {
                        selected.push(floorOptions.find(option => option.value === "Other"));
                    }

                    // Update selectedFloors state with the array of selected options
                    setSelectedFloors(selected);



                    const options = await fetchCompanyData("");
                    // console.log(options);
                    let defaultCompanyGroupObj = options?.find((company) => (company.label).includes(responseData.Company));
                    // console.log(defaultCompanyGroupObj);
                    let defaultRelationship = await api.getRelationship(defaultCompanyGroupObj?.value)
                    // console.log(defaultRelationship);

                    setSelectedCompany({
                        value: defaultCompanyGroupObj?.value,
                        label: defaultCompanyGroupObj?.label,
                    });

                    setSelectedGroup({
                        value: defaultCompanyGroupObj?.groupId,
                        label: defaultCompanyGroupObj?.group,
                    });

                    // console.log(defaultRelationship);
                    // setSelectRelationship(responseData.Relationship)
                    if (defaultRelationship.Response?.Data) {
                        let defaultRelationshipObj = defaultRelationship.Response?.Data?.find((relationship) => (relationship.Relationship_Name).includes(responseData.Relationship));
                        // console.log(defaultRelationshipObj);
                        setSelectRelationship({
                            value: defaultRelationshipObj?.Relationship_ID,
                            label: defaultRelationshipObj?.Relationship_Name
                        });
                    }
                    setCompanyOptions(options);

                    setOpportunityData({
                        Topic: responseData.Topic || "",
                        OppId: responseData.OppId || "",
                        OppStatus: responseData.Statuscode || "",
                        leadname: responseData.leadname || "",
                        OriginatingLead: responseData.OriginatingLead || "",
                        LeadId: responseData.LeadId || "",
                        ContactPerson: responseData.ContactPerson || "",
                        Emailaddress: responseData.Emailaddress || "",
                        Mobilephone: responseData.Mobilephone || "",
                        Buildingname: responseData.Buildingname || "",
                        BuildingNo: responseData.BuildingNo || "",
                        Block: responseData.Block || "",
                        Floor: responseData.Floor || "",
                        PostalCode: responseData.PostalCode || "",
                        Companyname: responseData.leadname || "",
                        Status: responseData.Status || "",
                        Statuscode: responseData.Statuscode || "",
                        Status: responseData.Status || "",
                        nameOfHotel: hotelInfo?.NameOfHotel || "",
                        latitude: hotelInfo?.Latitude || "",
                        longitude: hotelInfo?.Longitude || "",
                        spectraRFS: hotelInfo?.SpectraRFS || "",
                        numberOfRooms: hotelInfo?.NumberOfRooms || "",
                        leasePeriod: hotelInfo?.DurationOfLease || "",
                        numberOfFloors: hotelInfo?.NoOfFloors || "",
                        roomsPerFloor: hotelInfo?.RoomsPerFloor || "",
                        roomRent: hotelInfo?.DailyRoomRentAvg || "",
                        hotelInternetRatings: hotelInfo?.PgInternetRatings || "",
                        googleRatings: hotelInfo?.GoogleRatings || "",
                        detailsofTVs: hotelInfo?.DetailsOfTvsCctvIot || "",
                        otherDesignation: hotelInfo.DesignationOthers || "",
                        otherExistingInternetOutflow: hotelInfo.OtherExistingInternetOutFlowPerMonth || "",
                        otherExistingInternetProvider: hotelInfo.OtherExistingInternetProvider || "",
                        OtherCurrentInfra: hotelInfo.OtherCurrentInfra || "",
                        PpOthers: hotelInfo.PpOthers || "",
                        commonAreaName: pgInfo?.CommonName,

                        // ssId :  hotelInfo.SSID || "",
                        ssId :  responseData?.PgInfo.SSID || "",


                        painPoints: [
                            hotelInfo.AccessIssuesAuthentication === "1" && "AccessIssuesAuthentication",
                            hotelInfo.UnableToEnhanceExperience === "1" && "UnableToEnhanceExperience",
                            hotelInfo.LackOfItExpertise === "1" && "LackOfItExpertise",
                            hotelInfo.OutDatedSetup === "1" && "OutDatedSetup",
                            hotelInfo.ServiceSupportChallenges === "1" && "ServiceSupportChallenges",
                            hotelInfo.CustommerComplaints === "1" && "CustommerComplaints",
                            hotelInfo.Other === "1" && "Other",
                        ].filter(Boolean),
                    });



                    const paymentoption = paymentoptions.find((opt) => opt.value === pgInfo.PaymentTerms) || null;
                    // setselectPayment(paymentoption);
                    const painPointOptions = [];
                    if (hotelInfo.AccessIssuesAuthentication === "1")
                        painPointOptions.push({ value: "AccessIssuesAuthentication", label: "Access issues Authentication" });
                    if (hotelInfo.UnableToEnhanceExperience === "1")
                        painPointOptions.push({ value: "UnableToEnhanceExperience", label: "Unable To Enhance Experience" });
                    if (hotelInfo.LackOfItExpertise === "1")
                        painPointOptions.push({ value: "LackOfItExpertise", label: "Lack Of It Expertise" });
                    if (hotelInfo.OutDatedSetup === "1")
                        painPointOptions.push({
                            value: "OutDatedSetup",
                            label: "Out dated Setup",
                        });
                    if (hotelInfo.ServiceSupportChallenges === "1")
                        painPointOptions.push({ value: "ServiceSupportChallenges", label: "Service Support Challenges" });
                    if (hotelInfo.CustommerComplaints === "1")
                        painPointOptions.push({ value: "CustommerComplaints", label: "Customer Complaints" });
                    if (hotelInfo.Other === "1")
                        painPointOptions.push({ value: "Other", label: "Others" });
                    setSelectPainPoints(painPointOptions);

                    setleadid(responseData.LeadId);

                    setStatusCode(responseData.Statuscode);
                    setStatus(responseData.Status);
                    setSelectSociety(responseData.SocietyName);

                    setSelectedFirmType(firmtype.find(item => item.value === responseData.Firmtype));

                    let getBuilding = await api.getBuilding({ areaName: responseData.AreaId, areaCode: responseData?.AreaId })


                    let defaultBuilding = getBuilding?.Response?.Data?.find((building) => building.BuildingCode == responseData?.BuildingId)
                    if (defaultBuilding) {
                        // console.log(defaultBuilding);
                        setSelectBuilding({
                            value: defaultBuilding.BuildingCode,
                            label: defaultBuilding.BuildingName
                        })
                    }


                    setSelectCountry({
                        value: responseData.Country,
                        label: responseData.Country,
                    });
                    setSelectState({
                        value: responseData.StateId,
                        label: responseData.State,
                    })
                    setSelectCity({
                        value: responseData.CityId,
                        label: responseData.City,
                    })
                    setSelectArea({
                        value: responseData.AreaId,
                        label: responseData.Area,
                    })
                    setSelectIndustry({
                        value: responseData.IndustryId,
                        label: responseData.Industry,
                    })

                    const filterCustomerSegment = optionCustomerSeg.find(item => item.value === String(responseData.CustomerSegment)).label;


                    setSelectCustomerSeg(
                        {
                            value: responseData.CustomerSegment,
                            label: filterCustomerSegment,
                        });
                    // console.log("responseData.TurnOver",responseData.TurnOver);

                    const filterTurnOver = optionTurnOver?.find(item => item.value === String(responseData?.TurnOver)).label;
                    // console.log("filterTurnOver",filterTurnOver);

                    setSelectTurnOver(
                        {
                            value: responseData.TurnOver,
                            label: filterTurnOver,
                        });



                } else {
                    console.error("Error fetching opportunity data:", responseData?.Message);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []);


    const handleWon = async () => {

        try {
            setLoading(true);
            const apiUrl = process.env.REACT_APP_API_URL;
            const requestData = {
                Action: "wonOpportunity",
                Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                oppid: OppId,
                password: sessionStorage.getItem('password'),
                reason: "",
                siteId: "",
                userName: sessionStorage.getItem('userName'),
            };
            // console.log(requestData);return


            const response = await fetch(apiUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(requestData),
            });

            const data = await response.json();
            // console.log(data);

            // Check for a successful API response
            if (data.Response.StatusCode == 200) {
                toast.success("Opportunity marked as Won", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
                setTimeout(() => {
                    window.location.reload();
                }, 1500);

            } else {
                toast.warning(data.Response.Message, {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });

            }
        } catch (error) {
            console.error("Error during API call:", error);
        } finally {
            setLoading(false);
        }

    };




    const handleSendToApproval = () => {
        try {
            Swal.fire({
                title: '<div style="font-size: 22px; margin-top:5px;">Action Required</div>',
                text: "Please submit for approval as discount added in OTC or RC amount",
                confirmButtonText:
                    '<span style="font-size: 15px;">Submit for Approval</span>',
                confirmButtonColor: "rgb(148,101,170)",
            }).then(async (result) => {
                if (result.isConfirmed) {
                    const { value: formValues } = await Swal.fire({
                        title: `<div style="font-size: 15px;padding: 10px;">Enter Reason for Discount</div>`,
                        // html: `<div style="font-size: 15px;">Reason of Payment DOA</div>`,
                        html: `
                                              <input id="swal-input1" class="swal2-input">  `,
                        focusConfirm: false,
                        preConfirm: () => {
                            // return [document.getElementById("swal-input1").value];
                            const reason = document.getElementById("swal-input1").value.trim();
                            if (!reason) {
                                Swal.showValidationMessage("Reason is required.");
                                return;
                            }
                            return reason;
                        }
                    });
                    if (formValues) {
                        const ApiUrl = process.env.REACT_APP_API_URL;
                        const requestBody = {
                            "Action": "createApproval",
                            "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                            "userName": sessionStorage.getItem('userName'),
                            "password": sessionStorage.getItem('password'),
                            "oppid": OppId ? OppId : "",
                            "reason": formValues
                        };
                        const Response = await fetch(ApiUrl, {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                            },
                            body: JSON.stringify(requestBody),
                        });
                        const data = await Response.json();
                        // console.log(data)
                        if (data.Status == "Success") {
                            toast.success(data.Response.Message, {
                                position: toast.POSITION.BOTTOM_CENTER,
                                autoClose: 1500,
                            });
                            window.location.reload()
                        }
                    }
                }
            })
        }
        catch (error) {
            console.error("Error during API call:", error);
        }
    }


    const checkRequiredFields = (payload) => {
        for (const key in payload) {
            // console.log(key, ":", payload[key]);

            if (payload[key] === "" || payload[key] === null) {
                // console.log(payload[key]);
                toast.error(`Required field: ${key}`, {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
                return false; // Stop execution if any field is empty
            }
        }
        return true; // All fields are valid
    };





    const handleUpdateOpportunity = async () => {
        try {


            // event.preventDefault(); // Prevent default submission
            if (!selectSolutaton.value) {
                toast.warning("Please Select Salutation", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
            } else if (selectedFirmType.value == "0") {
                toast.warning("Please Select Firm Type", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
            } else if (!opportunityData.ContactPerson) {
                toast.warning("Please Enter Contact Person Name", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
            } else if (!opportunityData.Emailaddress) {
                toast.warning("Please Enter Contact Person Email", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
            } else if (!opportunityData.Mobilephone) {
                toast.warning("Please Enter Mobile Number", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
            } else if (!selectState.value) {
                toast.warning("Please Select State", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
            }
            else if (!selectCity.value) {
                toast.warning("Please Select City", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
            }
            else if (!selectArea.value) {
                toast.warning("Please Select Area", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
            } else if (!opportunityData.Floor) {
                toast.warning("Please Enter Floor", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
            } else if (!opportunityData.PostalCode) {
                toast.warning("Please Enter Postal Code", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
            }

            else if (!opportunityData.numberOfRooms) {
                toast.warning("Please Enter Number Of Rooms", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
            } else if (!opportunityData.roomRent) {
                toast.warning("Please Enter Daily Room Rent", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
            } else if (!opportunityData.numberOfFloors) {
                toast.warning("Please Enter Number Of Floor", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
            } else if (!opportunityData.roomsPerFloor) {
                toast.warning("Please Enter Room Per Floor", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
            } else if (!opportunityData.detailsofTVs) {
                toast.warning("Please Enter Details of TVs/CCTV/IOT", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
            }
            else if (!commonArea) {
                toast.error("Please select a Common Area.", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
            } else if (commonArea.value === "111260000" && !opportunityData.commonAreaName) {
                toast.error("Please enter the Common Area Name.", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
            } else if (!selectedFloors || selectedFloors.length === 0) {
                toast.error("Please select at least one floor.", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
            }
            else if (!isNaN(parseInt(opportunityData.numberOfFloors, 10)) && (selectedFloors?.length !== parseInt(opportunityData.numberOfFloors, 10))) {
                toast.warning("Selected floors must be equal to Number of Floors.", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
            }
            

            else if (!selectClientProfile.value) {
                toast.warning("Please Select Client Profile", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
            } else if (!selectPropertyType.value) {
                toast.warning("Please Select Property Type", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
            } else if (!selectExistingInternetProvider.value) {
                toast.warning("Please Select Existing Internet Provider", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
            } else if (!selectExistingInternetOutflow.value) {
                toast.warning("Please Select Existing Internet Outflow", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
            } else if (!selectSpectraRelationship.value) {
                toast.warning("Please Select Spectra Relationship", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
            }
            else {
                setLoading(true);
                const apiUrl = process.env.REACT_APP_API_URL
                const payload = {
                    "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    "Action": "updateopportunityHotel",
                    "userName": sessionStorage.getItem('userName'),
                    "password": sessionStorage.getItem('password'),

                    "block": opportunityData?.Block || "",
                    "societyId": null,
                    "housePlotFlatNo": opportunityData?.BuildingNo || "",
                    "blockTowerNumber": null,
                    "otcAmount": "",
                    "sdAmount": null,
                    "oppId": OppId ? OppId : "",
                    // "oppId": "O-06-2025-98032",
                    "priceList": "",
                    "topic": opportunityData?.Topic || "",
                    "salutation": selectSolutaton?.value || "",
                    "mobilephone": opportunityData?.Mobilephone || "",
                    "media": "1",
                    "lco": null,
                    "industry": selectIndustry.value || "",
                    "floor": opportunityData?.Floor || "",
                    "firmtype": selectedFirmType?.value || "",
                    "existingprovider": "569480014",
                    "emailaddress": opportunityData?.Emailaddress || "",
                    "country": "10001",
                    "state": selectState?.value || "",
                    "city": selectCity?.value || "",
                    "area": selectArea?.value || "",
                    "buildingname": selectBuilding?.value || "",
                    "postalCode": opportunityData?.PostalCode || "",
                    "buildingNo": opportunityData?.BuildingNo || "",
                    "contactPerson": opportunityData?.ContactPerson || "",
                    "customerSegment": "111260000",
                    "upTimesla": "",
                    "firewall": "",
                    "companySelf": "",
                    "poLock": "",
                    "firewallAwc": null,
                    "poNext": "",
                    "redunancy": true,
                    "createAreaOrBuilding": true,
                    "turnOver": "",
                    "reason": "...",
                    "specificArea": null,
                    "specificBuilding": null,
                    "noOfUsers": null,
                    "noOfBeds": null,
                    "typeOfOrder": null,
                    "pocClosureDate": null,
                    "OTCDiscountAmount": null,
                    "SDDiscountAmount": null,
                    "OTCExtendedAmount": null,
                    "SDExtendedAmount": null,
                    "Remarks": null,

                    "CommonArea": commonArea ? commonArea.value : "",
                    "CommonName": opportunityData.commonAreaName || "",
                    "Elevator": "",
                    "ElevatorCount": "",
                    BasementCoverageRequired: floorCoverage.Basement,
                    GroundFloorCoverageRequired: floorCoverage.Ground,
                    FirstFloorCoverageRequired: floorCoverage.First,
                    SecondFloorCoverageRequired: floorCoverage.Second,
                    ThirdFloorCoverageRequired: floorCoverage.Third,
                    FourthFloorCoverageRequired: floorCoverage.Fourth,
                    FifthFloorCoverageRequired: floorCoverage.Fifth,
                    SixthFloorCoverageRequired: floorCoverage.Sixth,
                    SeventhFloorCoverageRequired: floorCoverage.Seventh,
                    EighthFloorCoverageRequired: floorCoverage.Eighth,
                    NinthFloorCoverageRequired: floorCoverage.Ninth,
                    TenthFloorCoverageRequired: floorCoverage.Tenth,
                    AnyAreaFloorCoverageRequired: floorCoverage.Other,
                    // Floor-specific room counts
                    NoOfRoomsinBasement: basementRooms,
                    NoOfRoomsinGroundFloor: groundRooms,
                    NoOfRoomsinFirstFloor: firstRooms,
                    NoOfRoomsinSecondFloor: secondRooms,
                    NoOfRoomsinThirdFloor: thirdRooms,
                    NoOfRoomsinFourthFloor: fourthRooms,
                    NoOfRoomsinFifthFloor: fifthRooms,
                    NoOfRoomsinSixthFloor: sixthRooms,
                    NoOfRoomsinSeventhFloor: seventhRooms,
                    NoOfRoomsinEighthFloor: eighthRooms,
                    NoOfRoomsinNinthFloor: ninthRooms,
                    NoOfRoomsinTenthFloor: tenthRooms,
                    NoOfRoomsinAnyotherAreaFloor: otherRooms,
                    // Floor-specific bed counts
                    NoOfBedsInBasement: basementBeds,
                    NoOfBedsInGroundFloor: groundBeds,
                    NoOfBedsInFirstFloor: firstBeds,
                    NoOfBedsInSecondFloor: secondBeds,
                    NoOfBedsInThirdFloor: thirdBeds,
                    NoOfBedsInFourthFloor: fourthBeds,
                    NoOfBedsInFifthFloor: fifthBeds,
                    NoOfBedsInSixthFloor: sixthBeds,
                    NoOfBedsInSeventhFloor: seventhBeds,
                    NoOfBedsInEightFloor: eighthBeds, // API field: "NoOfBedsInEightFloor"
                    NoOfBedsInNinthFloor: ninthBeds,
                    NoOfBedsInTenthFloor: tenthBeds,
                    NoOfBedsInAnyAreaFloor: otherBeds,
                    "HotelInfo": {
                        "Barriers": barrier || "",
                        "NumberOfRooms": opportunityData?.numberOfRooms || "",
                        "RoomsPerFloor": opportunityData?.roomsPerFloor || "",
                        "DailyRoomRentAvg": opportunityData?.roomRent || "",
                        "NoOfFloors": opportunityData?.numberOfFloors || "",
                        "Latitude": opportunityData?.latitude || "",
                        "Longitude": opportunityData?.longitude || "",
                        "ClientProfile": selectClientProfile?.value,
                        "TypeOfProperty": selectPropertyType?.value,
                        "DurationOfLease": opportunityData?.leasePeriod || "",
                        "DetailsOfTvsCctvIot": opportunityData?.detailsofTVs || "",
                        "ExistingInternetProvider": selectExistingInternetProvider?.value || "",
                        "OtherExistingInternetProvider": opportunityData?.otherExistingInternetProvider || "",
                        "ExistingInternetOutFlowPerMonth": selectExistingInternetOutflow?.value || "",
                        "OtherExistingInternetOutFlowPerMonth": opportunityData?.otherExistingInternetOutflow || "",
                        "CurrentInfra": selectCurrentInfra?.value || "",
                        "OtherCurrentInfra": opportunityData?.OtherCurrentInfra || "",
                        "SpectraRFS": opportunityData?.spectraRFS || "",
                        "SpectraRelationship": selectSpectraRelationship?.value || "",
                        "PgInternetRatings": opportunityData?.hotelInternetRatings,
                        "GoogleRatings": opportunityData?.googleRatings || "",

                        "AccessIssuesAuthentication": opportunityData.painPoints?.includes("AccessIssuesAuthentication") ? "1" : "0",
                        "UnableToEnhanceExperience": opportunityData.painPoints?.includes("UnableToEnhanceExperience") ? "1" : "0",
                        "OutDatedSetup": opportunityData.painPoints?.includes("OutDatedSetup") ? "1" : "0",
                        "LackOfItExpertise": opportunityData.painPoints?.includes("LackOfItExpertise") ? "1" : "0",
                        "CustommerComplaints": opportunityData.painPoints?.includes("CustommerComplaints") ? "1" : "0",
                        "ServiceSupportChallenges": opportunityData.painPoints?.includes("ServiceSupportChallenges") ? "1" : "0",
                        "Other": opportunityData.painPoints?.includes("Other") ? "1" : "0",
                        "PpOthers": opportunityData?.PpOthers || "",
                        "SSID" : opportunityData?.ssId,
                    }
                }
                // Send API request
                const response = await fetch(apiUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(payload),
                });

                const result = await response.json();
                if (result?.Status === "Success") {
                    toast.success("Opportunity updated successfully!", {
                        position: toast.POSITION.BOTTOM_CENTER,
                        autoClose: 1500,
                    });
                    navigate("/businessOpportunityHotel");
                    // setTimeout(() => {
                    //     window.location.reload()
                    // }, 1500);
                } else {
                    toast.warning(result?.Response?.Message, {
                        position: toast.POSITION.BOTTOM_CENTER,
                        autoClose: 1500,
                    });
                    return
                }
            }
        } catch (error) {
            console.error("Error updating opportunity:", error);
        } finally {
            setLoading(false);
        }
    };




    useEffect(() => {
        const fetchGetIndustry = async () => {
            try {
                const apiUrl = process.env.REACT_APP_API_URL;
                const requestData = {
                    Action: "getindustrytype",
                    Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    areaCode: "",
                    areaName: "",
                    password: sessionStorage.getItem("password"),
                    userName: sessionStorage.getItem("userName"),
                };

                const response = await fetch(apiUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(requestData),
                });

                const result = await response.json();
                if (result.Status == "Success") {
                    const industryType = result.Response.map(
                        (option) => ({
                            label: option.IndTypeName,
                            value: option.IndTypeId,
                        })
                    );
                    const updatedtransformedOptions = industryType.filter(item => !['IND_0073_ID','IND_0072_ID','IND_0074_ID','IND_0068_ID'].includes(item.value));
                    setindustrydropdetails(updatedtransformedOptions);
                }
            } catch (error) {
                console.error("Error fetching data:", error.message);
            } finally {

            }
        };

        fetchGetIndustry();
    }, []);



    useEffect(() => {
        const fetchData = async () => {
            try {
                const apiUrl = process.env.REACT_APP_API_URL;
                const payload = {
                    Action: "getPricelist",
                    Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    buildingname: selectSociety ? selectSociety : "",
                    password: sessionStorage.getItem('password'),
                    userName: sessionStorage.getItem('userName')
                };
                const response = await fetch(apiUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(payload),
                });

                const result = await response.json();

                if (result?.Status === "Success" && result?.Response?.Data) {

                    const priceList = result.Response.Data.map(
                        (option) => ({
                            label: option.PriceName,
                            value: option.PriceName,
                        })
                    );
                    setPriceListOptions(priceList);

                } else {
                    console.error("Failed to retrieve price list:", result);
                }
            } catch (error) {
                console.error("Error fetching price list:", error);
            }
        }; fetchData();
    }, [selectSociety]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const apiUrl = process.env.REACT_APP_API_URL;
                const payload = {
                    Action: "getProductlist",
                    Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    oppid: OppId ? OppId : "",
                    reason: "",
                    siteId: "",
                    password: sessionStorage.getItem('password'),
                    userName: sessionStorage.getItem('userName'),
                };

                // Send API request
                const response = await fetch(apiUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(payload),
                });
                const result = await response.json();
                // console.log(result);

                if (result?.Status === "Success") {
                    // const productList = result.Response.Data.map(item => item.ProductId);
                    // console.log("result.Response.Data", result.Response.Data)
                    const productList = result.Response.Data.map(
                        (option) => ({
                            label: option.ProductId,
                            value: option.ProductId,
                        })
                    );
                    setProductOptions(productList);
                }
            } catch (error) {
                console.error("Error fetching product list:", error);
            }
        }; fetchData();
    }, []);

    const relatedProductChange = async (selectedOption) => {
        // console.log(selectedOption);
        // selectedOption.value.includes("-RC")
        setSelectedRelatedProduct(selectedOption);

        if (selectedOption.value.includes("-OTC")) {
            setDiscountFlag("OTC")
            // setOpportunityData((prevData) => ({
            //   ...prevData,
            //   otcDiscount: ""
            // }));
        } else if (selectedOption.value.includes("-RC")) {
            setDiscountFlag("RC")
            // setOpportunityData((prevData) => ({
            //   ...prevData,
            //   rcDiscount: ""
            // }));
        } else {
            setDiscountFlag()
        }
    }


    const handleProductChange = async (selectedOption) => {
        setSelectedProduct(selectedOption);
        try {
            const apiUrl = process.env.REACT_APP_API_URL;
            const requestBody = {
                Action: "createOppProduct",
                Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                oppid: OppId ? OppId : "",
                password: sessionStorage.getItem('password'),
                productid: selectedOption.value,
                userName: sessionStorage.getItem('userName'),
            };
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(requestBody),
            });

            const responsedata = await response.json();

            if (responsedata.Status == "Failure") {
                toast.warning(responsedata.Response.Message.Message, {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
            }

        } catch (error) {
            // Handle fetch error
            console.error("Error fetching data:", error);
        }
    };

    const redirectoppPage = () => {
        Swal.fire({
            html: '<div style="font-size: 15px;">Do you want to go back to the previous screen?</div>',
            showCancelButton: true,
            confirmButtonText:
                '<span style="font-size: 12px;color:rgb(148,101,170);">YES</span>',
            cancelButtonText:
                '<span style="font-size: 12px;color:rgb(148,101,170);">NO</span>',
            confirmButtonColor: "white",
            cancelButtonColor: "white",
            customClass: {
                popup: "custom-popup",
                confirmButton: "custom-confirm-button",
                cancelButton: "custom-cancel-button",
            },
        }).then((result) => {
            if (result.isConfirmed) {
                navigate("/businessOpportunityHotel");
            }
        });
    };



    // const fetchCompanyData = async () => {
    //     try {
    //         setLoader(true);
    //         const apiUrl = process.env.REACT_APP_API_URL;
    //         const requestBody = {
    //             Action: "getCompany",
    //             Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
    //             companyId: "New Company",
    //             password: sessionStorage.getItem('password'),
    //             userName: sessionStorage.getItem('userName'),
    //         };

    //         const response = await fetch(apiUrl, {
    //             method: "POST",
    //             headers: {
    //                 "Content-Type": "application/json",
    //             },
    //             body: JSON.stringify(requestBody),
    //         });
    //         const data = await response.json();
    //         // console.log("conpany name :", data.Response.Data);
    //         if (data.Status === "Success" && data.StatusCode === "200") {
    //             return data.Response.Data.map((company) => ({
    //                 label: `${company.Company_Name} (${company.Company_ID})`,
    //                 value: company.Company_ID,
    //                 group: `${company.Group_Name} (${company.Group_ID})`,
    //                 groupId: company.Group_ID,
    //             }));
    //         } else {
    //             console.error("Error in API response:", data);
    //             return [];
    //         }
    //     } catch (error) {
    //         console.error("Error fetching company data:", error);
    //     } finally {
    //         setLoader(false);
    //     }
    //     return [];
    // };

    useEffect(() => {
        const fetchCities = async () => {
            try {
                // City API call
                const cityApiUrl = process.env.REACT_APP_API_URL;
                const cityRequestBody = {
                    Action: "getCity",
                    Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    password: sessionStorage.getItem('password'),
                    stateCode: selectState.value,
                    userName: sessionStorage.getItem('userName'),
                };
                const cityResponse = await fetch(cityApiUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(cityRequestBody),
                });
                const cityData = await cityResponse.json();

                if (cityData.Response && Array.isArray(cityData.Response.Data)) {
                    const filteredCities = cityData.Response.Data.filter(
                        (city) => city.IsOperationalCity === true
                    );
                    setCityType(filteredCities);
                } else {
                    // console.error(
                    //   "City data structure not recognized:",
                    //   cityData.Response
                    // );

                    setCityType([]);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        if (selectState) {
            fetchCities();
        }
    }, [selectState]);



    const handleSelectCity = async (selectedOption) => {
        const selectedCityCode = selectedOption ? selectedOption.value : "";
        const selectedCityName = selectedOption ? selectedOption.label : "";
        // console.log("selectedCityCode", selectedOption.value);
        // console.log("selectedCityName", selectedOption.label);
        setSelectCity(selectedOption);
        setSelectArea("");
        // setSelectBuilding("");
        try {
            const areaApiUrl = process.env.REACT_APP_API_URL;
            const areaRequestBody = {
                Action: "getArea",
                Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                cityCode: selectedCityCode,
                cityName: selectedCityName,
                password: sessionStorage.getItem('password'),
                restrictedarea: false,
                stateCode: "",
                userName: sessionStorage.getItem('userName'),
            };
            const areaResponse = await fetch(areaApiUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(areaRequestBody),
            });
            const areaData = await areaResponse.json();
            if (areaData.Response && Array.isArray(areaData.Response.Data)) {
                // console.log("area :", areaData.Response.Data);
                setAreaList(areaData.Response.Data);
            }
        } catch (error) {
            console.error("Error fetching area data:", error);
        }
    };

    const handleSelectArea = async (selectedOption) => {
        try {
            // console.log(selectedOption);

            setSelectArea(selectedOption);
            setSelectBuilding("");


            let payload = {
                areaCode: selectedOption.value,
                areaName: selectedOption.label.split(" ")[0]
            }
            let getBuilding = await api.getBuilding(payload);
            // console.log("getBuilding: ", getBuilding);

            if (getBuilding.Response && Array.isArray(getBuilding.Response.Data)) {
                setBuildingList(getBuilding.Response.Data);
            }
        } catch (error) {
            console.error("Error fetching building data:", error);
        }
    };




    { console.log("proposalCounter", proposalCounter) }


    return (
        <>
            {/* ***********Header********* */}
            <div className="container-fluid text-light Header-style header">
                <div className="p-3">
                    <span
                        className=""
                        style={{ cursor: "pointer" }}
                        onClick={redirectoppPage}
                    >
                        <i className="fa-solid fa-arrow-left-long"></i>
                    </span>
                    <span className="p-1 m-3" >Update Opportunity Hotel</span>
                    {opportunityData.Status.toLowerCase() == "won" && (
                        <span className=" flr-createCAf" onClick={handleCreateCaf} style={{ fontSize: "10px" }}>
                            Create CAF
                        </span>
                    )}



                </div>
            </div>

            {/* ************Header end************ */}

            {loading ? (
                <div className="loader-wrapper">
                    <div className="loader">
                        <img src={load} alt="loading...."></img>
                    </div>
                </div>
            ) : (
                <form>

                    <div className="container-fluid mb-4 form-container">
                        {meetingcounter !== "" && Number(meetingcounter) >= 1 && (
                            <>
                                {(opportunityData.Status !== "Won") && (


                                    <div>
                                        {!showForm ? (
                                            <button
                                                type="button"
                                                className="btn btn-dark w-100 mt-2 text-light"
                                                onClick={() => setShowForm(true)}
                                            >
                                                LOST
                                            </button>
                                        ) : (
                                            <>
                                                <Select
                                                    isMulti
                                                    options={optionQualify}
                                                    value={selectedReasons}
                                                    onChange={setSelectedReasons}
                                                    styles={customStyles}
                                                    components={{ MultiValueRemove }}
                                                    className="basic-multi-select disqualify-select"
                                                    classNamePrefix="select"
                                                    placeholder="Select Disqualify Reason(s)..."
                                                    isSearchable={false}
                                                />

                                                {/* show the input only if "Other" was chosen */}
                                                {selectedReasons.some(r => r.value === "other") && (
                                                    <div className='other-disqualify'>
                                                        <input
                                                            type="text"
                                                            className="form-control mt-2"
                                                            placeholder="Please specify..."
                                                            value={otherText}
                                                            onChange={e => setOtherText(e.target.value)}
                                                        />
                                                    </div>
                                                )}

                                                <div className="d-flex justify-content-center gap-2 mt-3 mb-2">
                                                    <button
                                                        type="button"
                                                        className="btn text-light bg-dark rounded-pill submit-btn"
                                                        onClick={handleLost}
                                                        disabled={
                                                            !selectedReasons.length ||
                                                            (selectedReasons.some(r => r.value === "other") && !otherText.trim())
                                                        }
                                                    >
                                                        Lost
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="btn text-light bg-dark rounded-pill submit-btn"
                                                        onClick={() => {
                                                            setShowForm(false);
                                                            setSelectedReasons([]);
                                                            setOtherText("");
                                                        }}
                                                    >
                                                        Cancel
                                                    </button>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                )}
                                {(opportunityData.Status !== "Won") && (
                                    <div>
                                        <button
                                            type='button'
                                            className="btn w-100 mt-2 qualify-btn text-light"
                                            onClick={handleWon}
                                        >
                                            WON
                                        </button>
                                    </div>
                                )}
                                {/* <button
                                    type='button'
                                    className="btn w-100 mt-2 qualify-btn text-light"
                                    onClick={ }
                                >
                                    LOST
                                </button> */}

                            </>
                        )}
                        {(getRcDiscount && getRcDiscount > 0 && getOtcDiscount && getOtcDiscount > 0 && opportunityData?.Statuscode !== "Waiting for Approval" && opportunityData?.Statuscode !== "Approved" && opportunityData?.Statuscode !== "Won") && (
                            <>
                                {!(parseFloat(opportunityData?.OTCAmount) <= parseFloat(getOtcDiscount) ||
                                    parseFloat(opportunityData?.RCAmount) <= parseFloat(getRcDiscount)) && (
                                        <button
                                            type="button"
                                            className="btn w-100 mt-2 qualify-btn text-light"
                                            onClick={handleSendToApproval}
                                        >
                                            Submit for Approval
                                        </button>
                                    )}
                            </>
                        )}

                        {/* **************Opportunity Details toggle******************* */}
                        <div className="contact-toggle mt-3" onClick={() => handleIconClick("form1")}
                        >
                            <span className="toggle-text">Opportunity Details</span>
                            <span className=" float-end">
                                <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
                            </span>
                        </div>

                        {activeForm === "form1" && (
                            <div className="container shadow  mb-3 bg-body rounded mt-4" id="form1">
                                <fieldset className="contact-form p-2">


                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder="Opportunity ID"
                                            className="form-control input-text form-control-sm mt-1"
                                            id="Topic"
                                            name="Topic"
                                            disabled={proposalCounter != ""}
                                            style={{ backgroundColor: 'transparent' }}
                                            value={opportunityData.Topic}
                                            onChange={handleChange}
                                        />
                                        <label htmlFor="Opportunity" className='mt-2'>Topic*</label>
                                    </div>

                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder="Opportunity ID"
                                            className="form-control input-text form-control-sm mt-1"
                                            id="Opportunity"
                                            name="OppId"
                                            value={opportunityData.OppId}
                                            onChange={handleChange}

                                            style={{ backgroundColor: 'transparent' }}
                                            readOnly
                                        />
                                        <label htmlFor="Opportunity" className='mt-2'>Opportunity ID*</label>
                                    </div>

                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder="Opportunity ID"
                                            className="form-control input-text form-control-sm mt-1"
                                            id="Opportunity"
                                            name="OppId"
                                            value={opportunityData.OppStatus}
                                            onChange={handleChange}
                                            style={{ backgroundColor: 'transparent' }}
                                            readOnly
                                        />
                                        <label htmlFor="Opportunity" className='mt-2'>Opportunity Status*</label>
                                    </div>




                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder="Lead Name"
                                            className="form-control input-text form-control-sm mt-1"
                                            id="leadname"
                                            name="leadname"
                                            value={opportunityData.leadname}
                                            onChange={handleChange}
                                            readOnly
                                            style={{ backgroundColor: 'transparent' }}
                                        />
                                        <label htmlFor="leadname" className='mt-2'>Lead Name*</label>
                                    </div>

                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder=""
                                            className="form-control input-text form-control-sm mt-1"
                                            id="Originating"
                                            name="Originating"
                                            value={opportunityData.OriginatingLead}
                                            onChange={handleChange}
                                            readOnly
                                            style={{ backgroundColor: 'transparent' }}
                                        />
                                        <label htmlFor="floatingInput" className='mt-2'>Originating Lead*</label>
                                    </div>

                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder=""
                                            className="form-control input-text form-control-sm mt-1"
                                            id="Leadid"
                                            name="Leadid"
                                            value={opportunityData.LeadId}
                                            // onChange={handleChange}
                                            readOnly
                                            style={{ backgroundColor: 'transparent' }}

                                        />
                                        <label htmlFor="floatingInput" className='mt-2'>Lead ID*</label>

                                    </div>


                                    <div className="">
                                        <label className="select-search-label mt-1">Company*</label>
                                        <Select
                                            className=" form-control form-control-sm p-1"
                                            id="companySelect"
                                            name="company"
                                            placeholder="Search Company"
                                            value={selectedCompany}
                                            styles={style}
                                            isLoading={loaders}
                                            isDisabled={true}
                                            onChange={(selectedOption) => {
                                                handleCompanyChange(selectedOption);
                                                //   (selectedOption.label !== "New Company" && !leadName) && setLeadName(selectedOption.label)
                                                //   setCompanyName(
                                                //     selectedOption &&
                                                //       selectedOption.label !== "New Company"
                                                //       ? selectedOption.label
                                                //       : ""
                                                //   );
                                            }}
                                            options={companyOptions}
                                            isSearchable={true}
                                        />
                                    </div>

                                    {/* {console.log("groupOptions ",groupOptions)} */}
                                    <div className="">
                                        <label className="select-search-label mt-1">Group*</label>
                                        <Select
                                            className=" basic-single form-control form-control-sm p-1"
                                            classNamePrefix="select"
                                            name="relationship"
                                            placeholder="Select Group"
                                            styles={style}
                                            // value={groupOptions.length > 0 ? groupOptions[0].value : null}
                                            value={selectedGroup}
                                            isSearchable={false}
                                            onChange={handleSelectGroup}
                                            options={groupOptions}
                                            isDisabled={true}
                                        />
                                    </div>

                                    {/* {console.log("relationship",selectRelationship)} */}
                                    <div className="">
                                        <label className="select-search-label mt-1">
                                            Relationship*
                                        </label>
                                        <Select
                                            className=" basic-single form-control form-control-sm  p-1"
                                            classNamePrefix="select"
                                            name="relationship"
                                            placeholder="Select Relationship"
                                            styles={style}
                                            value={selectRelationship}
                                            isSearchable={false}
                                            onChange={handleSelectRelationship}
                                            options={relationshipOptions.map((data) => ({
                                                value: data.value,
                                                label: data.label,
                                            }))}
                                            isDisabled={true}
                                        />
                                    </div>



                                </fieldset>
                            </div>
                        )}
                        {/* **************Contact Person Details toggle******************* */}
                        <div className="Lead-Channel-toggle mt-3" onClick={() => handleIconClick("form2")}
                        >
                            <span className="toggle-text">Contact Person Details</span>
                            <span className=" float-end">
                                <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
                            </span>
                        </div>

                        {activeForm === "form2" && (
                            <div className="container shadow mb-3 bg-body rounded mt-4" id="form2">
                                <fieldset className="Lead-Channel-form p-2">

                                    <div className="">
                                        <label className="select-search-label mt-1">
                                            Salutation*
                                        </label>
                                        <Select
                                            className=" basic-single form-control form-control-sm p-1"
                                            classNamePrefix="select"
                                            name="Salutation"
                                            placeholder="Select Salutation"
                                            styles={style}
                                            value={selectSolutaton}
                                            isDisabled={proposalCounter != ""}
                                            isSearchable={false}
                                            onChange={handleSelectSolutation}
                                            options={optionSolutation.map((data) => ({
                                                value: data.value,
                                                label: data.label,
                                            }))}
                                        />
                                    </div>

                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder="Contact Person Name"
                                            className="form-control input-text form-control-sm mt-1"
                                            id="contactPerson"
                                            name="ContactPerson"
                                            value={opportunityData.ContactPerson}
                                            onChange={handleChange}
                                            disabled={proposalCounter != ""}
                                            style={{ backgroundColor: 'transparent' }}
                                        />
                                        <label htmlFor="contactPerson" className='mt-2'>Contact Person Name*</label>
                                    </div>

                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder="Email"
                                            className="form-control input-text form-control-sm mt-1"
                                            id="contactEmail"
                                            name="Emailaddress"
                                            value={opportunityData.Emailaddress}
                                            onChange={handleChange}
                                            disabled={proposalCounter != ""}
                                            style={{ backgroundColor: 'transparent' }}
                                        />
                                        <label htmlFor="contactEmail" className='mt-2'>Email*</label>
                                    </div>

                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder="Mobile Number"
                                            className="form-control input-text form-control-sm mt-1"
                                            id="Mobilephone"
                                            name="Mobilephone"
                                            value={opportunityData.Mobilephone}
                                            onChange={handleChange}
                                            disabled={proposalCounter != ""}
                                            style={{ backgroundColor: 'transparent' }}
                                        />
                                        <label htmlFor="contactMobile" className='mt-2'>Mobile Number*</label>
                                    </div>


                                    <div className="select-container mt-2">
                                        <label className="select-search-label">Role*</label>
                                        <Select
                                            className="basic-single form-control form-control-sm p-1"
                                            classNamePrefix="select"
                                            name="role"
                                            placeholder="Select"
                                            styles={style}
                                            value={selectRole}
                                            isSearchable={false}
                                            isDisabled={proposalCounter != ""}
                                            style={{ backgroundColor: 'transparent' }}
                                            onChange={handleSelectRole}
                                            options={[
                                                { value: "111260000", label: "KDM" },
                                                { value: "111260001", label: "Influencer" },
                                            ]}
                                        />
                                    </div>

                                    <div className="select-container mt-2">
                                        <label className="select-search-label">Contact Designation*</label>
                                        <Select
                                            className="basic-single form-control form-control-sm p-1"
                                            classNamePrefix="select"
                                            name="contactDesignation"
                                            placeholder="Select"
                                            styles={style}
                                            value={selectContactDesignation}
                                            isSearchable={false}
                                            isDisabled={proposalCounter != ""}
                                            style={{ backgroundColor: 'transparent' }}
                                            onChange={handleSelectContactDesignation}
                                            options={[
                                                { value: "111260000", label: "Owner" },
                                                { value: "111260001", label: "Manager" },
                                                { value: "111260002", label: "CareTaker" },
                                                { value: "111260003", label: "Other" },
                                                { value: "111260004", label: "Admin Manager" },
                                                { value: "111260005", label: "IT / Network Manager" },
                                                { value: "111260006", label: "Receptionist" },
                                                { value: "111260007", label: "Manager" },
                                                { value: "111260008", label: "General Manager" },
                                                { value: "111260009", label: "Owner/Director" },
                                                { value: "111260010", label: "Sales" },
                                                { value: "111260011", label: "IT" },
                                                { value: "111260012", label: "Procurement" },
                                            ]}
                                        />
                                    </div>

                                    {selectContactDesignation.value == "111260003" &&
                                        <div className="input-box form-floating">
                                            <input
                                                type="text"
                                                placeholder="Mobile Number"
                                                className="form-control input-text form-control-sm mt-1"
                                                id="otherDesignation"
                                                name="otherDesignation"
                                                value={opportunityData.otherDesignation}
                                                onChange={handleChange}
                                                disabled={proposalCounter != ""}
                                                style={{ backgroundColor: 'transparent' }}
                                            />
                                            <label htmlFor="otherDesignation" className='mt-2'>Specific Designation</label>
                                        </div>}


                                    <div className="">
                                        <label className="select-search-label mt-1">Country*</label>
                                        <Select
                                            className=" basic-single form-control form-control-sm p-1"
                                            classNamePrefix="select"
                                            name="Country"
                                            placeholder="Select Country"
                                            styles={style}
                                            isSearchable={false}
                                            isDisabled={proposalCounter != ""}
                                            style={{ backgroundColor: 'transparent' }}
                                            value={{ label: "India", value: "10001" }}
                                            onChange={handleSelectCountry}
                                            options={optionCountry.map((data) => ({
                                                value: data.value,
                                                label: data.label,
                                            }))}
                                        />
                                    </div>

                                    <div className="">
                                        <label className="select-search-label mt-1">State*</label>
                                        <Select
                                            className=" basic-single form-control form-control-sm p-1"
                                            classNamePrefix="select"
                                            name="IndustrySeg"
                                            placeholder="Select State"
                                            isSearchable={false}
                                            isDisabled={proposalCounter != ""}
                                            style={{ backgroundColor: 'transparent' }}
                                            styles={style}
                                            value={selectState}
                                            onChange={handleSelectState}
                                            options={optionState.map((data) => ({
                                                value: data.code,
                                                label: data.name,
                                            }))}
                                        />
                                    </div>

                                    <div className="">
                                        <label className="select-search-label mt-1">City*</label>
                                        <Select
                                            className="basic-single form-control form-control-sm p-1"
                                            classNamePrefix="select"
                                            name="City"
                                            placeholder="Select City"
                                            isSearchable
                                            styles={style}
                                            isDisabled={proposalCounter != ""}
                                            style={{ backgroundColor: 'transparent' }}
                                            // value={cityType.find(
                                            //   (city) => city.CityCode === selectCity.value
                                            // )}
                                            value={selectCity}
                                            onChange={handleSelectCity}
                                            options={cityType.map((data) => ({
                                                value: data.CityCode,
                                                label: data.CityName,
                                            }))}
                                        />
                                    </div>

                                    <div className="search-area" style={{ position: "relative" }}>
                                        <label className="select-search-label mt-1">Area*</label>
                                        <Select
                                            options={areaList.map((area) => ({
                                                value: area.AreaCode,
                                                label: `${area.AreaName} (${area.AreaCode})`,
                                            }))}
                                            className="form-control form-control-sm p-1 custom-select"
                                            placeholder="Search Area"
                                            isSearchable
                                            styles={style}
                                            value={selectArea}
                                            isDisabled={proposalCounter != ""}
                                            style={{ backgroundColor: 'transparent' }}
                                            onChange={handleSelectArea}
                                        />
                                        <i
                                            className="fas fa-search text-secondary"
                                            style={{
                                                position: "absolute",
                                                right: "15px",
                                                top: "63%",
                                                transform: "translateY(-50%)",
                                            }}
                                        ></i>
                                    </div>


                                    <div className="search-area" style={{ position: "relative" }}>
                                        <label className="select-search-label mt-1">Building Name*</label>
                                        <Select
                                            options={buildingList.map((building) => ({
                                                value: building.BuildingCode,
                                                label: `${building.BuildingName} (${building.BuildingCode})`,
                                            }))}
                                            className="form-control form-control-sm p-1 custom-select"
                                            placeholder="Search Area"
                                            isSearchable
                                            styles={style}
                                            isDisabled={proposalCounter != ""}
                                            style={{ backgroundColor: 'transparent' }}
                                            value={selectBuilding}
                                            onChange={(selectedOption) =>
                                                setSelectBuilding(selectedOption)
                                            }
                                        />
                                        <i
                                            className="fas fa-search text-secondary"
                                            style={{
                                                position: "absolute",
                                                right: "15px",
                                                top: "63%",
                                                transform: "translateY(-50%)",
                                            }}
                                        ></i>
                                    </div>


                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder="Building Number"
                                            className="form-control input-text form-control-sm mt-1"
                                            id="buildingNum"
                                            name="BuildingNo"
                                            value={opportunityData.BuildingNo}
                                            onChange={handleChange}
                                            disabled={proposalCounter != ""}
                                            style={{ backgroundColor: 'transparent' }}
                                        />
                                        <label htmlFor="buildingNum" className='mt-2'>Building No./Plot No.*</label>
                                    </div>

                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder="Block"
                                            className="form-control input-text form-control-sm mt-1"
                                            id="block"
                                            name="Block"
                                            value={opportunityData.Block}
                                            onChange={handleChange}
                                            disabled={proposalCounter != ""}
                                            style={{ backgroundColor: 'transparent' }}
                                        />
                                        <label htmlFor="block" className='mt-2'>Block*</label>
                                    </div>

                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder="Floor"
                                            className="form-control input-text form-control-sm mt-1"
                                            id="floor"
                                            name="Floor"
                                            value={opportunityData.Floor}
                                            onChange={handleChange}
                                            disabled={proposalCounter != ""}
                                            style={{ backgroundColor: 'transparent' }}
                                        />
                                        <label htmlFor="floor" className='mt-2'>Floor*</label>
                                    </div>

                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder="Pin Code"
                                            className="form-control input-text form-control-sm mt-1"
                                            id="pin"
                                            name="PostalCode"
                                            value={opportunityData.PostalCode}
                                            onChange={handleChange}
                                            disabled={proposalCounter != ""}
                                            style={{ backgroundColor: 'transparent' }}
                                        />
                                        <label htmlFor="pin" className='mt-2'>Pin*</label>
                                    </div>
                                </fieldset>
                            </div>
                        )}

                        {/* **************Company Details toggle******************* */}
                        <div className="Company-details-toggle mt-3" onClick={() => handleIconClick("form3")}
                        >
                            <span className="toggle-text">Company Details</span>
                            <span className=" float-end">
                                <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
                            </span>
                        </div>

                        {activeForm === "form3" && (
                            <div className="container shadow mb-3 bg-body rounded mt-4" id="form3">
                                <fieldset className="Company-details-form p-2">
                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder="Company Name"
                                            className="form-control input-text form-control-sm mt-1"
                                            id="company"
                                            name="Companyname"
                                            value={opportunityData.Companyname || ""}
                                            onChange={handleChange}
                                            disabled={proposalCounter != ""}
                                            style={{ backgroundColor: 'transparent' }}
                                        />
                                        <label htmlFor="company" className='mt-2'>Company Name*</label>
                                    </div>


                                    <div className="input-box form-floating" style={{ position: "relative", paddingTop: "5px" }}>
                                        <input
                                            type="text"
                                            placeholder="Latitude"
                                            className="form-control input-text form-control-sm mt-2"
                                            id="latitude"
                                            name="latitude"
                                            value={opportunityData.latitude}
                                            onChange={handleChange}
                                            style={{ background: "transparent" }}
                                            disabled
                                        />
                                        <i
                                            className="fa-solid fa-lock text-secondary"
                                            style={{
                                                position: "absolute",
                                                right: "20px",
                                                top: "60%",
                                                transform: "translateY(-50%)",
                                            }}
                                        ></i>
                                        <label htmlFor="company" className='mt-1 LeadId'>Latitude*</label>
                                    </div>
                                    <div className="input-box form-floating" style={{ position: "relative", paddingTop: "5px" }}>
                                        <input
                                            type="text"
                                            placeholder="Longitude"
                                            className="form-control input-text form-control-sm mt-2"
                                            id="longitude"
                                            name="longitude"
                                            value={opportunityData.longitude}
                                            onChange={handleChange}
                                            style={{ background: "transparent" }}
                                            disabled
                                        />
                                        <i
                                            className="fa-solid fa-lock text-secondary"
                                            style={{
                                                position: "absolute",
                                                right: "20px",
                                                top: "60%",
                                                transform: "translateY(-50%)",
                                            }}
                                        ></i>
                                        <label htmlFor="company" className='mt-1 LeadId'>Longitude*</label>
                                    </div>

                                    <div className="input-box form-floating" style={{ position: "relative", paddingTop: "5px" }}>
                                        <input
                                            type="text"
                                            placeholder="spectraRFS"
                                            className="form-control input-text form-control-sm mt-2"
                                            id="spectraRFS"
                                            name="spectraRFS"
                                            value={opportunityData.spectraRFS}
                                            onChange={handleChange}
                                            style={{ background: "transparent" }}
                                            disabled
                                        />
                                        <i
                                            className="fa-solid fa-lock text-secondary"
                                            style={{
                                                position: "absolute",
                                                right: "20px",
                                                top: "60%",
                                                transform: "translateY(-50%)",
                                            }}
                                        ></i>
                                        <label htmlFor="spectraRFS" className='mt-1 LeadId'>Spectra RFS*</label>
                                    </div>



                                    <div className="">
                                        <label className="select-search-label mt-1">
                                            Firm Type*
                                        </label>
                                        <Select
                                            className=" basic-single form-control form-control-sm p-1"
                                            classNamePrefix="select"
                                            name="selectCustomerSeg"
                                            placeholder="Select"
                                            styles={style}
                                            value={selectedFirmType}
                                            isSearchable={false}
                                            onChange={handleSelectFirmType}
                                            options={firmtype}
                                            isDisabled={proposalCounter != ""}
                                            style={{ backgroundColor: 'transparent' }}
                                        />
                                    </div>


                                    <div className="">
                                        <label className="select-search-label mt-1">
                                            Industry Type*
                                        </label>
                                        <Select
                                            className="basic-single form-control form-control-sm p-1"
                                            classNamePrefix="select"
                                            placeholder="Select Option"
                                            id="IndustryType"
                                            name="IndustryType"
                                            styles={style}
                                            value={selectIndustry}
                                            isDisabled={proposalCounter != ""}
                                            style={{ backgroundColor: 'transparent' }}
                                            // isDisabled={true}
                                            onChange={handleIndustryChnage}
                                            options={industrydropdetails.map((data) => ({
                                                value: data.value,
                                                label: data.label,
                                            }))}

                                        />
                                    </div>




                                </fieldset>
                            </div>
                        )}
                        {/* **************PG Info toggle******************* */}
                        <div
                            className="Other-details-toggle mt-3"
                            onClick={() => handleIconClick("form222")}
                        >
                            <span className="toggle-text">Hotel Info</span>
                            <span className=" float-end">
                                <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
                            </span>
                        </div>


                        {activeForm === "form222" && (
                            <div
                                className=" container shadow mb-3 bg-body rounded mt-4"
                                id="form222"
                            >
                                {/**********PG Info form******** */}
                                <form className="contact-form pg-info-form p-2">


                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder="Mobile Phone"
                                            className="form-control input-text form-control-sm mt-1"
                                            id="nameOfHotel"
                                            name="nameOfHotel"
                                            value={opportunityData.nameOfHotel}
                                            onChange={handleChange}
                                            disabled={proposalCounter != ""}
                                            style={{ backgroundColor: 'transparent' }}
                                        />
                                        <label htmlFor="mobilephone" className='mt-2'>Name of Hotel*</label>
                                    </div>


                                    <div className="">
                                        <label className="select-search-label mt-1">Client Profile*</label>
                                        <Select
                                            className=" basic-single form-control form-control-sm p-1"
                                            classNamePrefix="select"
                                            name="ClientProfil"
                                            placeholder="Select"
                                            styles={style}
                                            value={selectClientProfile}
                                            isDisabled={proposalCounter != ""}
                                            style={{ backgroundColor: 'transparent' }}
                                            isSearchable={false}
                                            onChange={handleSelectClientProfil}
                                            options={optionClientProfil.map((data) => ({
                                                value: data.value,
                                                label: data.label,
                                            }))}
                                        />
                                    </div>


                                    <div className="">
                                        <label className="select-search-label mt-1">Property Type*</label>
                                        <Select
                                            className=" basic-single form-control form-control-sm p-1"
                                            classNamePrefix="select"
                                            name="ClientProfil"
                                            placeholder="Select"
                                            styles={style}
                                            value={selectPropertyType}
                                            isDisabled={proposalCounter != ""}
                                            style={{ backgroundColor: 'transparent' }}
                                            isSearchable={false}
                                            onChange={handleSelectPropertyType}
                                            options={optionPropertyType.map((data) => ({
                                                value: data.value,
                                                label: data.label,
                                            }))}
                                        />
                                    </div>


                                    {selectPropertyType?.value == "111260000" &&
                                        <div className="input-box form-floating" >
                                            <input
                                                type="text"
                                                placeholder="Mobile Phone"
                                                className="form-control input-text form-control-sm mt-1"
                                                id="leasePeriod"
                                                name="leasePeriod"
                                                value={opportunityData.leasePeriod}
                                                disabled={proposalCounter != ""}
                                                style={{ backgroundColor: 'transparent' }}
                                                onChange={handleChange}
                                                onKeyDown={(e) => {
                                                    const allowedKeys = [
                                                        "Backspace",
                                                        "Delete",
                                                        "ArrowLeft",
                                                        "ArrowRight",
                                                        "Tab",
                                                    ];
                                                    const isDigit = /\d/.test(e.key);
                                                    if (
                                                        (isDigit || allowedKeys.includes(e.key))
                                                        //   &&  (basePriceDis < 10 || e.key === "Backspace")
                                                    ) {
                                                        return true;
                                                    } else {
                                                        e.preventDefault();
                                                    }
                                                }}
                                            />

                                            <label htmlFor="leasePeriod" className='mt-2'>Lease Period (Years)</label>
                                        </div>}


                                    <div className="input-box form-floating" style={{ position: "relative", paddingTop: "5px" }}>
                                        <input
                                            type="text"
                                            placeholder=""
                                            className="form-control input-text form-control-sm mt-2"
                                            id="numberOfRooms"
                                            name="numberOfRooms"
                                            value={opportunityData.numberOfRooms}


                                            onChange={handleChange}
                                            readOnly={true}
                                            onKeyDown={(e) => {
                                                const allowedKeys = [
                                                    "Backspace",
                                                    "Delete",
                                                    "ArrowLeft",
                                                    "ArrowRight",
                                                    "Tab",
                                                ];
                                                const isDigit = /\d/.test(e.key);
                                                if (
                                                    (isDigit || allowedKeys.includes(e.key))
                                                    //   &&  (basePriceDis < 10 || e.key === "Backspace")
                                                ) {
                                                    return true;
                                                } else {
                                                    e.preventDefault();
                                                }
                                            }}
                                            style={{ background: "transparent" }}
                                        />
                                        <i
                                            className="fa-solid fa-lock text-secondary"
                                            style={{
                                                position: "absolute",
                                                right: "20px",
                                                top: "60%",
                                                transform: "translateY(-50%)",
                                            }}
                                        ></i>
                                        <label htmlFor="numberOfRooms" className="LeadId mt-1">Number of Room</label>
                                    </div>

                                    <div className="input-box form-floating" style={{ position: "relative", paddingTop: "5px" }}>
                                        <input
                                            placeholder=""
                                            className="form-control input-text form-control-sm mt-2"
                                            id="roomRent"
                                            name="roomRent"
                                            value={opportunityData.roomRent}
                                            onChange={handleChange}
                                            readOnly={true}
                                            style={{ background: "transparent" }}
                                            type="text"

                                            onKeyDown={(e) => {
                                                const allowedKeys = [
                                                    "Backspace",
                                                    "Delete",
                                                    "ArrowLeft",
                                                    "ArrowRight",
                                                    "Tab",
                                                ];
                                                const isDigit = /\d/.test(e.key);
                                                if (
                                                    (isDigit || allowedKeys.includes(e.key))
                                                    //   &&  (basePriceDis < 10 || e.key === "Backspace")
                                                ) {
                                                    return true;
                                                } else {
                                                    e.preventDefault();
                                                }
                                            }}
                                        />
                                        <i
                                            className="fa-solid fa-lock text-secondary"
                                            style={{
                                                position: "absolute",
                                                right: "20px",
                                                top: "60%",
                                                transform: "translateY(-50%)",
                                            }}
                                        ></i>
                                        <label htmlFor="roomRent" className="LeadId mt-1">Daily Room Rent (Avg.)</label>
                                    </div>

                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder=""
                                            className="form-control input-text form-control-sm mt-1"
                                            id="ssId"
                                            name="ssId"
                                            value={opportunityData.ssId}
                                            onChange={handleChange}
                                           
                                            style={{ background: "transparent" }}
                                        />
                                        <label htmlFor="ssId" className="mt-2">SSID</label>
                                    </div>

                                    <div className="input-box form-floating" >
                                        <input
                                            placeholder=""
                                            className="form-control input-text form-control-sm mt-2"
                                            id="numberOfFloors"
                                            name="numberOfFloors"
                                            value={opportunityData.numberOfFloors}
                                            onChange={handleChange}
                                            disabled={proposalCounter != ""}
                                            style={{ backgroundColor: 'transparent' }}
                                            type="text"

                                            onKeyDown={(e) => {

                                                const allowedKeys = [

                                                    "Backspace",

                                                    "Delete",

                                                    "ArrowLeft",

                                                    "ArrowRight",

                                                    "Tab",

                                                ];

                                                const isDigit = /\d/.test(e.key);

                                                if (

                                                    (isDigit || allowedKeys.includes(e.key))

                                                    //   &&  (basePriceDis < 10 || e.key === "Backspace")

                                                ) {

                                                    return true;

                                                } else {

                                                    e.preventDefault();

                                                }

                                            }}

                                        />

                                        <label htmlFor="numberOfFloors" className="LeadId mt-2">Number of Floors</label>
                                    </div>


                                    <div className="input-box form-floating" >
                                        <input
                                            placeholder=""
                                            className="form-control input-text form-control-sm mt-2"
                                            id="roomsPerFloor"
                                            name="roomsPerFloor"
                                            value={opportunityData.roomsPerFloor}
                                            onChange={handleChange}
                                            type="text"
                                            disabled={proposalCounter != ""}
                                            style={{ backgroundColor: 'transparent' }}
                                            onKeyDown={(e) => {
                                                const allowedKeys = [
                                                    "Backspace",
                                                    "Delete",
                                                    "ArrowLeft",
                                                    "ArrowRight",
                                                    "Tab",
                                                ];
                                                const isDigit = /\d/.test(e.key);
                                                if (
                                                    (isDigit || allowedKeys.includes(e.key))
                                                    //   &&  (basePriceDis < 10 || e.key === "Backspace")
                                                ) {
                                                    return true;
                                                } else {
                                                    e.preventDefault();
                                                }
                                            }}

                                        />

                                        <label htmlFor="roomsPerFloor" className="LeadId mt-2">Rooms Per Floor</label>
                                    </div>



                                    {/* Existing Internet Provider */}
                                    <div className="select-container mt-2">
                                        <label className="select-search-label">Existing Internet Provider</label>
                                        <Select
                                            className="basic-single form-control form-control-sm p-1"
                                            classNamePrefix="select"
                                            name="existingInternetProvider"
                                            placeholder="Select"
                                            styles={style}
                                            value={selectExistingInternetProvider}
                                            isDisabled={proposalCounter != ""}
                                            style={{ backgroundColor: 'transparent' }}
                                            isSearchable={false}
                                            onChange={handleSelectExistingInternetProvider}
                                            options={[
                                                { value: "111260000", label: "Airtel" },
                                                { value: "111260001", label: "Jio" },
                                                { value: "111260002", label: "Tata" },
                                                { value: "111260003", label: "ACT" },
                                                { value: "111260004", label: "New Building" },
                                                { value: "111260005", label: "Others" },
                                                { value: "111260006", label: "Excitel" },
                                                { value: "111260007", label: "Triple Play" },
                                            ]}
                                        />
                                    </div>

                                    {selectExistingInternetProvider?.value == "111260005" &&
                                        <div className="input-box form-floating">
                                            <input
                                                type="text"
                                                placeholder="Mobile Phone"
                                                className="form-control input-text form-control-sm mt-1"
                                                id="otherExistingInternetProvider"
                                                name="otherExistingInternetProvider"
                                                value={opportunityData.otherExistingInternetProvider}
                                                onChange={handleChange}
                                                disabled={proposalCounter != ""}
                                                style={{ backgroundColor: 'transparent' }}
                                            />
                                            <label htmlFor="otherExistingInternetProvider" className='mt-2'>Specific Existing Internet Provider</label>
                                        </div>}

                                    {/* Existing Internet Outflow Per Month */}
                                    <div className="select-container mt-2">
                                        <label className="select-search-label">Existing Internet Outflow Per Month</label>
                                        <Select
                                            className="basic-single form-control form-control-sm p-1"
                                            classNamePrefix="select"
                                            name="existingInternetOutflow"
                                            placeholder="Select"
                                            styles={style}
                                            isDisabled={proposalCounter != ""}
                                            style={{ backgroundColor: 'transparent' }}
                                            value={selectExistingInternetOutflow}
                                            isSearchable={false}
                                            onChange={handleSelectExistingInternetOutflow}
                                            options={[
                                                { value: "111260000", label: "<5000" },
                                                { value: "111260001", label: "5001 - 10000" },
                                                { value: "111260002", label: "10001- 15000" },
                                                { value: "111260003", label: "15001 - 20000" },
                                                { value: "111260004", label: "20001 - 25000" },
                                                { value: "111260005", label: ">25000" },
                                                { value: "111260006", label: "New Building" },
                                                { value: "111260007", label: "Others" },
                                                { value: "111260008", label: "10001 - 20000" },
                                                { value: "111260009", label: ">20,000" },
                                                { value: "1112600010", label: ">10,000" },
                                            ]}
                                        />
                                    </div>
                                    {selectExistingInternetOutflow?.value == "111260007" &&
                                        <div className="input-box form-floating">
                                            <input
                                                type="text"
                                                placeholder="Mobile Phone"
                                                className="form-control input-text form-control-sm mt-1"
                                                id="otherExistingInternetOutflow"
                                                name="otherExistingInternetOutflow"
                                                value={opportunityData.otherExistingInternetOutflow}
                                                onChange={handleChange}
                                                disabled={proposalCounter != ""}
                                                style={{ backgroundColor: 'transparent' }}
                                            />
                                            <label htmlFor="otherExistingInternetOutflow" className='mt-2'>Specific Existing Internet Outflow Per Month</label>
                                        </div>}



                                    {/* Pain Points - Multi-Select */}
                                    <div className="select-container mt-2">
                                        <label className="select-search-label">Pain Points</label>
                                        <Select
                                            className="basic-multi-select form-control form-control-sm p-1"
                                            classNamePrefix="select"
                                            name="painPoints"
                                            placeholder="Select"
                                            styles={style}
                                            value={selectPainPoints}
                                            isDisabled={proposalCounter != ""}
                                            style={{ backgroundColor: 'transparent' }}
                                            isMulti
                                            onChange={handleSelectPainPoints}
                                            options={[
                                                { value: "AccessIssuesAuthentication", label: "Access issues Authentication" },
                                                { value: "UnableToEnhanceExperience", label: "Unable To Enhance Experience" },
                                                { value: "OutDatedSetup", label: "Out dated Setup" },
                                                { value: "LackOfItExpertise", label: "Lack Of It Expertise" },
                                                { value: "CustommerComplaints", label: "Customer Complaints" },
                                                { value: "ServiceSupportChallenges", label: "Service Support Challenges" },
                                                { value: "Other", label: "Other" },
                                            ]}
                                        />
                                    </div>

                                    {/* {console.log("selectPainPoints",selectPainPoints)} */}


                                    {selectPainPoints?.some(point => point?.value === 'Other') &&
                                        <div className="input-box form-floating">
                                            <input
                                                type="text"
                                                placeholder="PpOthers"
                                                className="form-control input-text form-control-sm mt-1"
                                                id="PpOthers"
                                                name="PpOthers"
                                                value={opportunityData.PpOthers}
                                                onChange={handleChange}
                                                disabled={proposalCounter != ""}
                                                style={{ backgroundColor: 'transparent' }}
                                            />
                                            <label htmlFor="PpOthers" className='mt-2'>Specific Pain point</label>
                                        </div>}



                                    {/* Spectra Relationship */}
                                    <div className="select-container mt-2">
                                        <label className="select-search-label">Spectra Relationship</label>
                                        <Select
                                            className="basic-single form-control form-control-sm p-1"
                                            classNamePrefix="select"
                                            name="spectraRelationship"
                                            placeholder="Select"
                                            styles={style}
                                            value={selectSpectraRelationship}
                                            isDisabled={proposalCounter != ""}
                                            style={{ backgroundColor: 'transparent' }}
                                            isSearchable={false}
                                            onChange={handleSelectSpectraRelationship}
                                            options={[
                                                { value: "111260000", label: "Existing User" },
                                                { value: "111260001", label: "Past User" },
                                                { value: "111260002", label: "New" },
                                            ]}
                                        />
                                    </div>

                                    {/* Current Infra */}
                                    {/* <div className="select-container mt-2">
                                        <label className="select-search-label">Current Infra</label>
                                        <Select
                                            className="basic-single form-control form-control-sm p-1"
                                            classNamePrefix="select"
                                            name="currentInfra"
                                            placeholder="Select"
                                            styles={style}
                                            value={selectCurrentInfra}
                                            isSearchable={false}
                                            onChange={handleSelectCurrentInfra}
                                            options={[
                                                // Placeholder options; adjust these based on your requirements.
                                                { value: "111260000", label: "Broadband" },
                                                { value: "111260001", label: "Access Points" },
                                                { value: "111260002", label: "Others" },
                                            ]}
                                        />
                                    </div> */}

                                    {selectCurrentInfra?.value == "111260002" &&
                                        <div className="input-box form-floating">
                                            <input
                                                type="text"
                                                placeholder="Mobile Phone"
                                                className="form-control input-text form-control-sm mt-1"
                                                id="OtherCurrentInfra"
                                                name="OtherCurrentInfra"
                                                value={opportunityData.OtherCurrentInfra}
                                                onChange={handleChange}
                                                disabled={proposalCounter != ""}
                                                style={{ backgroundColor: 'transparent' }}
                                            />
                                            <label htmlFor="OtherCurrentInfra" className='mt-2'>Specific Current Infra</label>
                                        </div>}

                                    <div className="input-box form-floating" >
                                        <input
                                            type="text"
                                            placeholder=""
                                            className="form-control input-text form-control-sm mt-1"
                                            id="googleRatings"
                                            name="googleRatings"
                                            value={opportunityData.googleRatings}
                                            onChange={handleChange}
                                            style={{ background: "transparent" }}
                                            disabled={proposalCounter != ""}

                                        />

                                        <label htmlFor="googleRatings" className="mt-2">Hotel Google Rating</label>
                                    </div>

                                    <div className="input-box form-floating" >
                                        <input
                                            type="text"
                                            placeholder=""
                                            className="form-control input-text form-control-sm mt-1"
                                            id="hotelInternetRatings"
                                            name="hotelInternetRatings"
                                            disabled={proposalCounter != ""}
                                            style={{ backgroundColor: 'transparent' }}
                                            value={opportunityData.hotelInternetRatings}
                                            onChange={handleChange}

                                        />

                                        <label htmlFor="hotelInternetRatings" className="mt-2">Hotel Internet Rating</label>
                                    </div>

                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder=""
                                            className="form-control input-text form-control-sm mt-1"
                                            id="detailsofTVs"
                                            name="detailsofTVs"
                                            disabled={proposalCounter != ""}
                                            style={{ backgroundColor: 'transparent' }}
                                            value={opportunityData.detailsofTVs}
                                            onChange={handleChange}
                                        // style={{ background: "transparent" }}
                                        />
                                        <label htmlFor="detailsofTVs" className="mt-2">Details of TVs / CCTV / IOT</label>
                                    </div>

                                    {/* Common Area Dropdown */}
                                    <div className="select-container mt-2">
                                        <label className="select-search-label">Common Area*</label>
                                        <Select
                                            name="commonArea"
                                            styles={style}
                                            disabled={proposalCounter != ""}
                                            style={{ backgroundColor: 'transparent' }}
                                            value={commonArea}
                                            onChange={setCommonArea}
                                            options={commonAreaOptions}
                                            className="basic-single form-control form-control-sm p-1"
                                            classNamePrefix="select"
                                            isSearchable={false}
                                        />
                                    </div>
                                    {commonArea && commonArea.value === "111260000" && (
                                        <div className="input-box form-floating mt-2">
                                            <input
                                                type="text"
                                                placeholder=""
                                                disabled={proposalCounter != ""}
                                                style={{ backgroundColor: 'transparent' }}
                                                className="form-control input-text form-control-sm mt-1"
                                                id="commonAreaName"
                                                name="commonAreaName"
                                                value={opportunityData.commonAreaName || ""}
                                                onChange={handleChange}

                                            />
                                            <label htmlFor="commonAreaName" className="mt-2">
                                                Common Area Name*
                                            </label>
                                        </div>
                                    )}


                                    {/* Multi Select for Floors */}
                                    <div className="select-container mt-2">
                                        <label className="select-search-label">Select the floors*</label>
                                        <Select
                                            name="selectedFloors"
                                            isMulti
                                            styles={style}
                                            isDisabled={proposalCounter != ""}
                                            style={{ backgroundColor: 'transparent' }}
                                            value={selectedFloors}
                                            onChange={handleFloorSelectChange}
                                            options={floorOptions}
                                            className="basic-multi-select form-control form-control-sm p-1"
                                            classNamePrefix="select"
                                        />
                                    </div>

                                    {/* Conditional fields for each floor based on floorCoverage flag */}

                                    <>
                                        {/* Basement */}
                                        {floorCoverage.Basement === "111260000" && (
                                            <>
                                                <div className="input-box form-floating mt-2">
                                                    <input
                                                        type="text"
                                                        id="basementRooms"
                                                        name="basementRooms"
                                                        value={basementRooms}
                                                        disabled={proposalCounter != ""}
                                                        style={{ backgroundColor: 'transparent' }}
                                                        onChange={(e) => {
                                                            const value = parseInt(e.target.value, 10);
                                                            setBasementRooms(isNaN(value) ? "" : value);
                                                        }}
                                                        onKeyDown={(e) => {
                                                            const allowedKeys = [
                                                                "Backspace",
                                                                "Delete",
                                                                "ArrowLeft",
                                                                "ArrowRight",
                                                                "Tab",
                                                            ];
                                                            const isDigit = /\d/.test(e.key);
                                                            if (isDigit || allowedKeys.includes(e.key)) {
                                                                return true;
                                                            } else {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        className="form-control input-text form-control-sm mt-1"
                                                        placeholder=""

                                                        min="0"
                                                    />
                                                    <label htmlFor="basementRooms" className="mt-2">
                                                        No. of Rooms in Basement*
                                                    </label>
                                                </div>

                                                {/* <div className="input-box form-floating">
                                                    <input
                                                        type="text"
                                                        id="basementBeds"
                                                        name="basementBeds"
                                                        value={basementBeds}
                                                        onChange={(e) => {
                                                            const value = parseInt(e.target.value, 10);
                                                            setBasementBeds(isNaN(value) ? "" : value);
                                                        }}
                                                        onKeyDown={(e) => {
                                                            const allowedKeys = [
                                                                "Backspace",
                                                                "Delete",
                                                                "ArrowLeft",
                                                                "ArrowRight",
                                                                "Tab",
                                                            ];
                                                            const isDigit = /\d/.test(e.key);
                                                            if (isDigit || allowedKeys.includes(e.key)) {
                                                                return true;
                                                            } else {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        className="form-control input-text form-control-sm mt-1"
                                                        placeholder=""
                                                        disabled={proposalCounter != ""}
                                                        style={{ backgroundColor: 'transparent' }}
                                                        min="0"
                                                    />
                                                    <label htmlFor="basementBeds" className="mt-2">
                                                        Number of Beds in Basement*
                                                    </label>
                                                </div> */}
                                            </>
                                        )}

                                        {/* Ground Floor */}
                                        {floorCoverage.Ground === "111260000" && (
                                            <>
                                                <div className="input-box form-floating mt-2">
                                                    <input
                                                        type="text"
                                                        id="groundRooms"
                                                        name="groundRooms"
                                                        value={groundRooms}
                                                        onChange={(e) => {
                                                            const value = parseInt(e.target.value, 10);
                                                            setGroundRooms(isNaN(value) ? "" : value);
                                                        }}
                                                        onKeyDown={(e) => {
                                                            const allowedKeys = [
                                                                "Backspace",
                                                                "Delete",
                                                                "ArrowLeft",
                                                                "ArrowRight",
                                                                "Tab",
                                                            ];
                                                            const isDigit = /\d/.test(e.key);
                                                            if (isDigit || allowedKeys.includes(e.key)) {
                                                                return true;
                                                            } else {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        className="form-control input-text form-control-sm mt-1"
                                                        placeholder=""
                                                        disabled={proposalCounter != ""}
                                                        style={{ backgroundColor: 'transparent' }}
                                                        min="0"
                                                    />
                                                    <label htmlFor="groundRooms" className="mt-2">
                                                        No. of Rooms in Ground Floor*
                                                    </label>
                                                </div>
                                                {/* <div className="input-box form-floating">
                                                    <input
                                                        type="text"
                                                        id="groundBeds"
                                                        name="groundBeds"
                                                        value={groundBeds}
                                                        onChange={(e) => {
                                                            const value = parseInt(e.target.value, 10);
                                                            setGroundBeds(isNaN(value) ? "" : value);
                                                        }}
                                                        onKeyDown={(e) => {
                                                            const allowedKeys = [
                                                                "Backspace",
                                                                "Delete",
                                                                "ArrowLeft",
                                                                "ArrowRight",
                                                                "Tab",
                                                            ];
                                                            const isDigit = /\d/.test(e.key);
                                                            if (isDigit || allowedKeys.includes(e.key)) {
                                                                return true;
                                                            } else {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        className="form-control input-text form-control-sm mt-1"
                                                        placeholder=""
                                                        disabled={proposalCounter != ""}
                                                        style={{ backgroundColor: 'transparent' }}
                                                        min="0"
                                                    />
                                                    <label htmlFor="groundBeds" className="mt-2">
                                                        Number of Beds in Ground Floor*
                                                    </label>
                                                </div> */}
                                            </>
                                        )}

                                        {/* First Floor */}
                                        {floorCoverage.First === "111260000" && (
                                            <>
                                                <div className="input-box form-floating mt-2">
                                                    <input
                                                        type="text"
                                                        id="firstRooms"
                                                        name="firstRooms"
                                                        value={firstRooms}
                                                        onChange={(e) => {
                                                            const value = parseInt(e.target.value, 10);
                                                            setFirstRooms(isNaN(value) ? "" : value);
                                                        }}
                                                        onKeyDown={(e) => {
                                                            const allowedKeys = [
                                                                "Backspace",
                                                                "Delete",
                                                                "ArrowLeft",
                                                                "ArrowRight",
                                                                "Tab",
                                                            ];
                                                            const isDigit = /\d/.test(e.key);
                                                            if (isDigit || allowedKeys.includes(e.key)) {
                                                                return true;
                                                            } else {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        className="form-control input-text form-control-sm mt-1"
                                                        placeholder=""
                                                        disabled={proposalCounter != ""}
                                                        style={{ backgroundColor: 'transparent' }}
                                                        min="0"
                                                    />
                                                    <label htmlFor="firstRooms" className="mt-2">
                                                        No. of Rooms in First Floor*
                                                    </label>
                                                </div>
                                                {/* <div className="input-box form-floating">
                                                    <input
                                                        type="text"
                                                        id="firstBeds"
                                                        name="firstBeds"
                                                        value={firstBeds}
                                                        onChange={(e) => {
                                                            const value = parseInt(e.target.value, 10);
                                                            setFirstBeds(isNaN(value) ? "" : value);
                                                        }}
                                                        onKeyDown={(e) => {
                                                            const allowedKeys = [
                                                                "Backspace",
                                                                "Delete",
                                                                "ArrowLeft",
                                                                "ArrowRight",
                                                                "Tab",
                                                            ];
                                                            const isDigit = /\d/.test(e.key);
                                                            if (isDigit || allowedKeys.includes(e.key)) {
                                                                return true;
                                                            } else {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        className="form-control input-text form-control-sm mt-1"
                                                        placeholder=""
                                                        disabled={proposalCounter != ""}
                                                        style={{ backgroundColor: 'transparent' }}
                                                        min="0"
                                                    />
                                                    <label htmlFor="firstBeds" className="mt-2">
                                                        Number of Beds in First Floor*
                                                    </label>
                                                </div> */}
                                            </>
                                        )}

                                        {/* Second Floor */}
                                        {floorCoverage.Second === "111260000" && (
                                            <>
                                                <div className="input-box form-floating mt-2">
                                                    <input
                                                        type="text"
                                                        id="secondRooms"
                                                        name="secondRooms"
                                                        value={secondRooms}
                                                        onChange={(e) => {
                                                            const value = parseInt(e.target.value, 10);
                                                            setSecondRooms(isNaN(value) ? "" : value);
                                                        }}
                                                        onKeyDown={(e) => {
                                                            const allowedKeys = [
                                                                "Backspace",
                                                                "Delete",
                                                                "ArrowLeft",
                                                                "ArrowRight",
                                                                "Tab",
                                                            ];
                                                            const isDigit = /\d/.test(e.key);
                                                            if (isDigit || allowedKeys.includes(e.key)) {
                                                                return true;
                                                            } else {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        className="form-control input-text form-control-sm mt-1"
                                                        placeholder=""
                                                        disabled={proposalCounter != ""}
                                                        style={{ backgroundColor: 'transparent' }}
                                                        min="0"
                                                    />
                                                    <label htmlFor="secondRooms" className="mt-2">
                                                        No. of Rooms in Second Floor*
                                                    </label>
                                                </div>
                                                {/* <div className="input-box form-floating">
                                                    <input
                                                        type="text"
                                                        id="secondBeds"
                                                        name="secondBeds"
                                                        value={secondBeds}
                                                        onChange={(e) => {
                                                            const value = parseInt(e.target.value, 10);
                                                            setSecondBeds(isNaN(value) ? "" : value);
                                                        }}
                                                        onKeyDown={(e) => {
                                                            const allowedKeys = [
                                                                "Backspace",
                                                                "Delete",
                                                                "ArrowLeft",
                                                                "ArrowRight",
                                                                "Tab",
                                                            ];
                                                            const isDigit = /\d/.test(e.key);
                                                            if (isDigit || allowedKeys.includes(e.key)) {
                                                                return true;
                                                            } else {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        className="form-control input-text form-control-sm mt-1"
                                                        placeholder=""
                                                        disabled={proposalCounter != ""}
                                                        style={{ backgroundColor: 'transparent' }}
                                                        min="0"
                                                    />
                                                    <label htmlFor="secondBeds" className="mt-2">
                                                        Number of Beds in Second Floor*
                                                    </label>
                                                </div> */}
                                            </>
                                        )}

                                        {/* Third Floor */}
                                        {floorCoverage.Third === "111260000" && (
                                            <>
                                                <div className="input-box form-floating mt-2">
                                                    <input
                                                        type="text"
                                                        id="thirdRooms"
                                                        name="thirdRooms"
                                                        value={thirdRooms}
                                                        onChange={(e) => {
                                                            const value = parseInt(e.target.value, 10);
                                                            setThirdRooms(isNaN(value) ? "" : value);
                                                        }}
                                                        onKeyDown={(e) => {
                                                            const allowedKeys = [
                                                                "Backspace",
                                                                "Delete",
                                                                "ArrowLeft",
                                                                "ArrowRight",
                                                                "Tab",
                                                            ];
                                                            const isDigit = /\d/.test(e.key);
                                                            if (isDigit || allowedKeys.includes(e.key)) {
                                                                return true;
                                                            } else {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        className="form-control input-text form-control-sm mt-1"
                                                        placeholder=""
                                                        disabled={proposalCounter != ""}
                                                        style={{ backgroundColor: 'transparent' }}
                                                        min="0"
                                                    />
                                                    <label htmlFor="thirdRooms" className="mt-2">
                                                        No. of Rooms in Third Floor*
                                                    </label>
                                                </div>
                                                {/* <div className="input-box form-floating">
                                                    <input
                                                        type="text"
                                                        id="thirdBeds"
                                                        name="thirdBeds"
                                                        value={thirdBeds}
                                                        onChange={(e) => {
                                                            const value = parseInt(e.target.value, 10);
                                                            setThirdBeds(isNaN(value) ? "" : value);
                                                        }}
                                                        onKeyDown={(e) => {
                                                            const allowedKeys = [
                                                                "Backspace",
                                                                "Delete",
                                                                "ArrowLeft",
                                                                "ArrowRight",
                                                                "Tab",
                                                            ];
                                                            const isDigit = /\d/.test(e.key);
                                                            if (isDigit || allowedKeys.includes(e.key)) {
                                                                return true;
                                                            } else {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        className="form-control input-text form-control-sm mt-1"
                                                        placeholder=""
                                                        disabled={proposalCounter != ""}
                                                        style={{ backgroundColor: 'transparent' }}
                                                        min="0"
                                                    />
                                                    <label htmlFor="thirdBeds" className="mt-2">
                                                        Number of Beds in Third Floor*
                                                    </label>
                                                </div> */}
                                            </>
                                        )}

                                        {/* Fourth Floor */}
                                        {floorCoverage.Fourth === "111260000" && (
                                            <>
                                                <div className="input-box form-floating mt-2">
                                                    <input
                                                        type="text"
                                                        id="fourthRooms"
                                                        name="fourthRooms"
                                                        value={fourthRooms}
                                                        onChange={(e) => {
                                                            const value = parseInt(e.target.value, 10);
                                                            setFourthRooms(isNaN(value) ? "" : value);
                                                        }}
                                                        onKeyDown={(e) => {
                                                            const allowedKeys = [
                                                                "Backspace",
                                                                "Delete",
                                                                "ArrowLeft",
                                                                "ArrowRight",
                                                                "Tab",
                                                            ];
                                                            const isDigit = /\d/.test(e.key);
                                                            if (isDigit || allowedKeys.includes(e.key)) {
                                                                return true;
                                                            } else {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        className="form-control input-text form-control-sm mt-1"
                                                        placeholder=""
                                                        disabled={proposalCounter != ""}
                                                        style={{ backgroundColor: 'transparent' }}
                                                        min="0"
                                                    />
                                                    <label htmlFor="fourthRooms" className="mt-2">
                                                        No. of Rooms in Fourth Floor*
                                                    </label>
                                                </div>
                                                {/* <div className="input-box form-floating">
                                                    <input
                                                        type="text"
                                                        id="fourthBeds"
                                                        name="fourthBeds"
                                                        value={fourthBeds}
                                                        onChange={(e) => {
                                                            const value = parseInt(e.target.value, 10);
                                                            setFourthBeds(isNaN(value) ? "" : value);
                                                        }}
                                                        onKeyDown={(e) => {
                                                            const allowedKeys = [
                                                                "Backspace",
                                                                "Delete",
                                                                "ArrowLeft",
                                                                "ArrowRight",
                                                                "Tab",
                                                            ];
                                                            const isDigit = /\d/.test(e.key);
                                                            if (isDigit || allowedKeys.includes(e.key)) {
                                                                return true;
                                                            } else {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        className="form-control input-text form-control-sm mt-1"
                                                        placeholder=""
                                                        disabled={proposalCounter != ""}
                                                        style={{ backgroundColor: 'transparent' }}
                                                        min="0"
                                                    />
                                                    <label htmlFor="fourthBeds" className="mt-2">
                                                        Number of Beds in Fourth Floor*
                                                    </label>
                                                </div> */}
                                            </>
                                        )}

                                        {/* Fifth Floor */}
                                        {floorCoverage.Fifth === "111260000" && (
                                            <>
                                                <div className="input-box form-floating mt-2">
                                                    <input
                                                        type="text"
                                                        id="fifthRooms"
                                                        name="fifthRooms"
                                                        value={fifthRooms}
                                                        onChange={(e) => {
                                                            const value = parseInt(e.target.value, 10);
                                                            setFifthRooms(isNaN(value) ? "" : value);
                                                        }}
                                                        onKeyDown={(e) => {
                                                            const allowedKeys = [
                                                                "Backspace",
                                                                "Delete",
                                                                "ArrowLeft",
                                                                "ArrowRight",
                                                                "Tab",
                                                            ];
                                                            const isDigit = /\d/.test(e.key);
                                                            if (isDigit || allowedKeys.includes(e.key)) {
                                                                return true;
                                                            } else {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        className="form-control input-text form-control-sm mt-1"
                                                        placeholder=""
                                                        sdisabled={proposalCounter != ""}
                                                        style={{ backgroundColor: 'transparent' }}
                                                        min="0"
                                                    />
                                                    <label htmlFor="fifthRooms" className="mt-2">
                                                        No. of Rooms in Fifth Floor*
                                                    </label>
                                                </div>
                                                {/* <div className="input-box form-floating">
                                                    <input
                                                        type="text"
                                                        id="fifthBeds"
                                                        name="fifthBeds"
                                                        value={fifthBeds}
                                                        onChange={(e) => {
                                                            const value = parseInt(e.target.value, 10);
                                                            setFifthBeds(isNaN(value) ? "" : value);
                                                        }}
                                                        onKeyDown={(e) => {
                                                            const allowedKeys = [
                                                                "Backspace",
                                                                "Delete",
                                                                "ArrowLeft",
                                                                "ArrowRight",
                                                                "Tab",
                                                            ];
                                                            const isDigit = /\d/.test(e.key);
                                                            if (isDigit || allowedKeys.includes(e.key)) {
                                                                return true;
                                                            } else {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        className="form-control input-text form-control-sm mt-1"
                                                        placeholder=""
                                                        disabled={proposalCounter != ""}
                                                        style={{ backgroundColor: 'transparent' }}
                                                        min="0"
                                                    />
                                                    <label htmlFor="fifthBeds" className="mt-2">
                                                        Number of Beds in Fifth Floor*
                                                    </label>
                                                </div> */}
                                            </>
                                        )}

                                        {/* Sixth Floor */}
                                        {floorCoverage.Sixth === "111260000" && (
                                            <>
                                                <div className="input-box form-floating mt-2">
                                                    <input
                                                        type="text"
                                                        id="sixthRooms"
                                                        name="sixthRooms"
                                                        value={sixthRooms}
                                                        onChange={(e) => {
                                                            const value = parseInt(e.target.value, 10);
                                                            setSixthRooms(isNaN(value) ? "" : value);
                                                        }}
                                                        onKeyDown={(e) => {
                                                            const allowedKeys = [
                                                                "Backspace",
                                                                "Delete",
                                                                "ArrowLeft",
                                                                "ArrowRight",
                                                                "Tab",
                                                            ];
                                                            const isDigit = /\d/.test(e.key);
                                                            if (isDigit || allowedKeys.includes(e.key)) {
                                                                return true;
                                                            } else {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        className="form-control input-text form-control-sm mt-1"
                                                        placeholder=""
                                                        disabled={proposalCounter != ""}
                                                        style={{ backgroundColor: 'transparent' }}
                                                        min="0"
                                                    />
                                                    <label htmlFor="sixthRooms" className="mt-2">
                                                        No. of Rooms in Sixth Floor*
                                                    </label>
                                                </div>
                                                {/* <div className="input-box form-floating">
                                                    <input
                                                        type="text"
                                                        id="sixthBeds"
                                                        name="sixthBeds"
                                                        value={sixthBeds}
                                                        onChange={(e) => {
                                                            const value = parseInt(e.target.value, 10);
                                                            setSixthBeds(isNaN(value) ? "" : value);
                                                        }}
                                                        onKeyDown={(e) => {
                                                            const allowedKeys = [
                                                                "Backspace",
                                                                "Delete",
                                                                "ArrowLeft",
                                                                "ArrowRight",
                                                                "Tab",
                                                            ];
                                                            const isDigit = /\d/.test(e.key);
                                                            if (isDigit || allowedKeys.includes(e.key)) {
                                                                return true;
                                                            } else {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        className="form-control input-text form-control-sm mt-1"
                                                        placeholder=""
                                                        disabled={proposalCounter != ""}
                                                        style={{ backgroundColor: 'transparent' }}
                                                        min="0"
                                                    />
                                                    <label htmlFor="sixthBeds" className="mt-2">
                                                        Number of Beds in Sixth Floor*
                                                    </label>
                                                </div> */}
                                            </>
                                        )}

                                        {/* Seventh Floor */}
                                        {floorCoverage.Seventh === "111260000" && (
                                            <>
                                                <div className="input-box form-floating mt-2">
                                                    <input
                                                        type="text"
                                                        id="seventhRooms"
                                                        name="seventhRooms"
                                                        value={seventhRooms}
                                                        onChange={(e) => {
                                                            const value = parseInt(e.target.value, 10);
                                                            setSeventhRooms(isNaN(value) ? "" : value);
                                                        }}
                                                        onKeyDown={(e) => {
                                                            const allowedKeys = [
                                                                "Backspace",
                                                                "Delete",
                                                                "ArrowLeft",
                                                                "ArrowRight",
                                                                "Tab",
                                                            ];
                                                            const isDigit = /\d/.test(e.key);
                                                            if (isDigit || allowedKeys.includes(e.key)) {
                                                                return true;
                                                            } else {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        className="form-control input-text form-control-sm mt-1"
                                                        placeholder=""
                                                        disabled={proposalCounter != ""}
                                                        style={{ backgroundColor: 'transparent' }}
                                                        min="0"
                                                    />
                                                    <label htmlFor="seventhRooms" className="mt-2">
                                                        No. of Rooms in Seventh Floor*
                                                    </label>
                                                </div>
                                                {/* <div className="input-box form-floating">
                                                    <input
                                                        type="text"
                                                        id="seventhBeds"
                                                        name="seventhBeds"
                                                        value={seventhBeds}
                                                        onChange={(e) => {
                                                            const value = parseInt(e.target.value, 10);
                                                            setSeventhBeds(isNaN(value) ? "" : value);
                                                        }}
                                                        onKeyDown={(e) => {
                                                            const allowedKeys = [
                                                                "Backspace",
                                                                "Delete",
                                                                "ArrowLeft",
                                                                "ArrowRight",
                                                                "Tab",
                                                            ];
                                                            const isDigit = /\d/.test(e.key);
                                                            if (isDigit || allowedKeys.includes(e.key)) {
                                                                return true;
                                                            } else {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        className="form-control input-text form-control-sm mt-1"
                                                        placeholder=""
                                                        disabled={proposalCounter != ""}
                                                        style={{ backgroundColor: 'transparent' }}
                                                        min="0"
                                                    />
                                                    <label htmlFor="seventhBeds" className="mt-2">
                                                        Number of Beds in Seventh Floor*
                                                    </label>
                                                </div> */}
                                            </>
                                        )}

                                        {/* Eighth Floor */}
                                        {floorCoverage.Eighth === "111260000" && (
                                            <>
                                                <div className="input-box form-floating mt-2">
                                                    <input
                                                        type="text"
                                                        id="eighthRooms"
                                                        name="eighthRooms"
                                                        value={eighthRooms}
                                                        onChange={(e) => {
                                                            const value = parseInt(e.target.value, 10);
                                                            setEighthRooms(isNaN(value) ? "" : value);
                                                        }}
                                                        onKeyDown={(e) => {
                                                            const allowedKeys = [
                                                                "Backspace",
                                                                "Delete",
                                                                "ArrowLeft",
                                                                "ArrowRight",
                                                                "Tab",
                                                            ];
                                                            const isDigit = /\d/.test(e.key);
                                                            if (isDigit || allowedKeys.includes(e.key)) {
                                                                return true;
                                                            } else {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        className="form-control input-text form-control-sm mt-1"
                                                        placeholder=""
                                                        disabled={proposalCounter != ""}
                                                        style={{ backgroundColor: 'transparent' }}
                                                        min="0"
                                                    />
                                                    <label htmlFor="eighthRooms" className="mt-2">
                                                        No. of Rooms in Eighth Floor*
                                                    </label>
                                                </div>
                                                {/* <div className="input-box form-floating">
                                                    <input
                                                        type="text"
                                                        id="eighthBeds"
                                                        name="eighthBeds"
                                                        value={eighthBeds}
                                                        onChange={(e) => {
                                                            const value = parseInt(e.target.value, 10);
                                                            setEighthBeds(isNaN(value) ? "" : value);
                                                        }}
                                                        onKeyDown={(e) => {
                                                            const allowedKeys = [
                                                                "Backspace",
                                                                "Delete",
                                                                "ArrowLeft",
                                                                "ArrowRight",
                                                                "Tab",
                                                            ];
                                                            const isDigit = /\d/.test(e.key);
                                                            if (isDigit || allowedKeys.includes(e.key)) {
                                                                return true;
                                                            } else {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        className="form-control input-text form-control-sm mt-1"
                                                        placeholder=""
                                                        disabled={proposalCounter != ""}
                                                        style={{ backgroundColor: 'transparent' }}
                                                        min="0"
                                                    />
                                                    <label htmlFor="eighthBeds" className="mt-2">
                                                        Number of Beds in Eighth Floor*
                                                    </label>
                                                </div> */}
                                            </>
                                        )}

                                        {/* Ninth Floor */}
                                        {floorCoverage.Ninth === "111260000" && (
                                            <>
                                                <div className="input-box form-floating mt-2">
                                                    <input
                                                        type="text"
                                                        id="ninthRooms"
                                                        name="ninthRooms"
                                                        value={ninthRooms}
                                                        onChange={(e) => {
                                                            const value = parseInt(e.target.value, 10);
                                                            setNinthRooms(isNaN(value) ? "" : value);
                                                        }}
                                                        onKeyDown={(e) => {
                                                            const allowedKeys = [
                                                                "Backspace",
                                                                "Delete",
                                                                "ArrowLeft",
                                                                "ArrowRight",
                                                                "Tab",
                                                            ];
                                                            const isDigit = /\d/.test(e.key);
                                                            if (isDigit || allowedKeys.includes(e.key)) {
                                                                return true;
                                                            } else {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        className="form-control input-text form-control-sm mt-1"
                                                        placeholder=""
                                                        disabled={proposalCounter != ""}
                                                        style={{ backgroundColor: 'transparent' }}
                                                        min="0"
                                                    />
                                                    <label htmlFor="ninthRooms" className="mt-2">
                                                        No. of Rooms in Ninth Floor*
                                                    </label>
                                                </div>
                                                {/* <div className="input-box form-floating">
                                                    <input
                                                        type="text"
                                                        id="ninthBeds"
                                                        name="ninthBeds"
                                                        value={ninthBeds}
                                                        onChange={(e) => {
                                                            const value = parseInt(e.target.value, 10);
                                                            setNinthBeds(isNaN(value) ? "" : value);
                                                        }}
                                                        onKeyDown={(e) => {
                                                            const allowedKeys = [
                                                                "Backspace",
                                                                "Delete",
                                                                "ArrowLeft",
                                                                "ArrowRight",
                                                                "Tab",
                                                            ];
                                                            const isDigit = /\d/.test(e.key);
                                                            if (isDigit || allowedKeys.includes(e.key)) {
                                                                return true;
                                                            } else {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        className="form-control input-text form-control-sm mt-1"
                                                        placeholder=""
                                                        disabled={proposalCounter != ""}
                                                        style={{ backgroundColor: 'transparent' }}
                                                        min="0"
                                                    />
                                                    <label htmlFor="ninthBeds" className="mt-2">
                                                        Number of Beds in Ninth Floor*
                                                    </label>
                                                </div> */}
                                            </>
                                        )}

                                        {/* Tenth Floor */}
                                        {floorCoverage.Tenth === "111260000" && (
                                            <>
                                                <div className="input-box form-floating mt-2">
                                                    <input
                                                        type="text"
                                                        id="tenthRooms"
                                                        name="tenthRooms"
                                                        value={tenthRooms}
                                                        onChange={(e) => {
                                                            const value = parseInt(e.target.value, 10);
                                                            setTenthRooms(isNaN(value) ? "" : value);
                                                        }}
                                                        onKeyDown={(e) => {
                                                            const allowedKeys = [
                                                                "Backspace",
                                                                "Delete",
                                                                "ArrowLeft",
                                                                "ArrowRight",
                                                                "Tab",
                                                            ];
                                                            const isDigit = /\d/.test(e.key);
                                                            if (isDigit || allowedKeys.includes(e.key)) {
                                                                return true;
                                                            } else {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        className="form-control input-text form-control-sm mt-1"
                                                        placeholder=""
                                                        disabled={proposalCounter != ""}
                                                        style={{ backgroundColor: 'transparent' }}
                                                        min="0"
                                                    />
                                                    <label htmlFor="tenthRooms" className="mt-2">
                                                        No. of Rooms in Tenth Floor*
                                                    </label>
                                                </div>
                                                {/* <div className="input-box form-floating">
                                                    <input
                                                        type="text"
                                                        id="tenthBeds"
                                                        name="tenthBeds"
                                                        value={tenthBeds}
                                                        onChange={(e) => {
                                                            const value = parseInt(e.target.value, 10);
                                                            setTenthBeds(isNaN(value) ? "" : value);
                                                        }}
                                                        onKeyDown={(e) => {
                                                            const allowedKeys = [
                                                                "Backspace",
                                                                "Delete",
                                                                "ArrowLeft",
                                                                "ArrowRight",
                                                                "Tab",
                                                            ];
                                                            const isDigit = /\d/.test(e.key);
                                                            if (isDigit || allowedKeys.includes(e.key)) {
                                                                return true;
                                                            } else {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        className="form-control input-text form-control-sm mt-1"
                                                        placeholder=""
                                                        disabled={proposalCounter != ""}
                                                        style={{ backgroundColor: 'transparent' }}
                                                        min="0"
                                                    />
                                                    <label htmlFor="tenthBeds" className="mt-2">
                                                        Number of Beds in Tenth Floor*
                                                    </label>
                                                </div> */}
                                            </>
                                        )}

                                        {/* Other Floor */}
                                        {floorCoverage.Other === "111260000" && (
                                            <>
                                                <div className="input-box form-floating mt-2">
                                                    <input
                                                        type="text"
                                                        id="otherRooms"
                                                        name="otherRooms"
                                                        value={otherRooms}
                                                        onChange={(e) => {
                                                            const value = parseInt(e.target.value, 10);
                                                            setOtherRooms(isNaN(value) ? "" : value);
                                                        }}
                                                        onKeyDown={(e) => {
                                                            const allowedKeys = [
                                                                "Backspace",
                                                                "Delete",
                                                                "ArrowLeft",
                                                                "ArrowRight",
                                                                "Tab",
                                                            ];
                                                            const isDigit = /\d/.test(e.key);
                                                            if (isDigit || allowedKeys.includes(e.key)) {
                                                                return true;
                                                            } else {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        className="form-control input-text form-control-sm mt-1"
                                                        placeholder=""
                                                        disabled={proposalCounter != ""}
                                                        style={{ backgroundColor: 'transparent' }}
                                                        min="0"
                                                    />
                                                    <label htmlFor="otherRooms" className="mt-2">
                                                        No. of Rooms in Other Floor*
                                                    </label>
                                                </div>
                                                {/* <div className="input-box form-floating">
                                                    <input
                                                        type="text"
                                                        id="otherBeds"
                                                        name="otherBeds"
                                                        value={otherBeds}
                                                        onChange={(e) => {
                                                            const value = parseInt(e.target.value, 10);
                                                            setOtherBeds(isNaN(value) ? "" : value);
                                                        }}
                                                        onKeyDown={(e) => {
                                                            const allowedKeys = [
                                                                "Backspace",
                                                                "Delete",
                                                                "ArrowLeft",
                                                                "ArrowRight",
                                                                "Tab",
                                                            ];
                                                            const isDigit = /\d/.test(e.key);
                                                            if (isDigit || allowedKeys.includes(e.key)) {
                                                                return true;
                                                            } else {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        className="form-control input-text form-control-sm mt-1"
                                                        placeholder=""
                                                        disabled={proposalCounter != ""}
                                                        style={{ backgroundColor: 'transparent' }}
                                                        min="0"
                                                    />
                                                    <label htmlFor="otherBeds" className="mt-2">
                                                        Number of Beds in Other Floor*
                                                    </label>
                                                </div> */}
                                            </>
                                        )}
                                    </>


                                </form>
                            </div>
                        )}



                        <div className="Remarks-toggle mt-3" onClick={redirectPriceCalPage}>
                            <span className="toggle-text">Plan Selector</span>
                            <span className=" float-end">
                                <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
                            </span>
                        </div>

                        <div className="Remarks-toggle mt-3" onClick={() => handleIconClick("form13")}
                        >
                            <span className="toggle-text">Proposal Details</span>
                            <span className=" float-end">
                                <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
                            </span>
                        </div>


                        {activeForm === "form13" && (
                            <div className="container shadow mb-3 bg-body rounded mt-4" id="form13">
                                <fieldset className="Remarks-form p-2">
                                    <div className="Other-details-toggle mt-3">

                                        <div className="row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-3">
                                            {allPraposalData && allPraposalData?.length > 0 ? (
                                                allPraposalData.map((data, index) => (
                                                    <div className="col" key={index}>
                                                        <div className="card mb-3">
                                                            <div className="m-3 card-data" style={{ display: "inline-flex" }} >
                                                                <div>
                                                                    {/* <p className="caf-card-text">Opportunity Id : {data.OpportunityID}</p>
                                  <p className="caf-card-text" style={{ textWrap: "nowrap" }}> Document Name : {data.ProposalDocName}</p> */}
                                                                    <p className="caf-card-text">Created On : {data.ProposalCreatedOn}</p>

                                                                </div>
                                                            </div>
                                                            <div className="d-flex justify-content-center gap-2 p-2">
                                                                <button type="button" className="btn qualify-btn text-light w-50" onClick={() => handleDownload(data)}>
                                                                    Download
                                                                </button>

                                                            </div>
                                                        </div>
                                                    </div>
                                                ))
                                            ) : (
                                                <div className="col-12 text-center">
                                                    <p>No data available.</p>
                                                </div>
                                            )}
                                        </div>



                                    </div>
                                </fieldset>
                            </div>
                        )}






                        <div className="Remarks-toggle mt-3" onClick={() => handleIconClick("form12")}
                        >
                            <span className="toggle-text">Quote Details</span>
                            <span className=" float-end">
                                <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
                            </span>
                        </div>


                        {activeForm === "form12" && (
                            <div className="container shadow mb-3 bg-body rounded mt-4" id="form12">
                                <fieldset className="Remarks-form p-2">
                                    <div className="Other-details-toggle mt-3">
                                        {/* <div className='mb-4'>
                                            <button
                                                type='button'
                                                className="btn w-100 mt-2 qualify-btn text-light"
                                                onClick={handleAddQuote}
                                            >
                                                Add Quote
                                            </button>
                                        </div> */}
                                        <div className="row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-3">
                                            {allQuoteData && allQuoteData?.length > 0 ? (
                                                allQuoteData.map((data, index) => (
                                                    <div className="col" key={index}>
                                                        <div className="card mb-3">
                                                            <div className="m-3 card-data" style={{ display: "flex", flexDirection: "column" }} >
                                                                <div>
                                                                    <p className="caf-card-text">Quote Id : {data.Quoteid}</p>
                                                                    <p className="caf-card-text">Total Amount : {data.TotalAmount}</p>
                                                                    <p className="caf-card-text" style={{lineHeight : "20px"}}>Opportunity Name : {data.OpportunityName}</p>
                                                                    <p className="caf-card-text">Status : {data.Status}</p>
                                                                    <p className="caf-card-text">Status Reason : {data.StatusReason}</p>
                                                                    {/* <p className="caf-card-text">Option Type : {data.OptionType}</p> */}
                                                                </div>
                                                            </div>
                                                            {meetingcounter !== "" && Number(meetingcounter) >= 1 && (
                                                                <>
                                                                    <div className="d-flex justify-content-center gap-2 p-2">
                                                                        <button type="button" className="btn qualify-btn text-light w-50"
                                                                         onClick={() => handleWonQoute(data.Quoteid)}
                                                                          disabled = {proposalOptionType == "Both"}
                                                                         >
                                                                            Won
                                                                        </button>
                                                                        <button type="button" className="btn qualify-btn text-light w-50" onClick={() => handleLostQoute(data.Quoteid)}>
                                                                            Lost
                                                                        </button>
                                                                    </div>
                                                                </>
                                                            )}
                                                        </div>
                                                    </div>
                                                ))
                                            ) : (
                                                <div className="col-12 text-center">
                                                    <p>No data available.</p>
                                                </div>
                                            )}
                                        </div>



                                    </div>
                                </fieldset>
                            </div>)}








                        {/* <div
                            className="Remarks-toggle mt-3"
                            onClick={() => handleIconClick("form6")}
                        >
                            <span className="toggle-text">Feasibilty</span>
                            <span className=" float-end">
                                <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
                            </span>
                        </div> */}


                        {activeForm === "form6" && (
                            <div
                                className="container shadow mb-3 bg-body rounded mt-4"
                                id="form6"
                            >
                                <div className="input-box form-floating p-3 select-search-label">
                                    {getFeasibilityData?.length > 0 ? getFeasibilityData?.map((data, index) => (
                                        <div className="input-box form-floating p-2" key={index}>
                                            <strong className=''>Feasibility Id: {data?.FeasibilityId || ""}</strong>
                                            <div>Route Type: {data?.RouteType ? "Redundant Route" : "Primary Route"}</div>
                                            <div>Owner: {data?.Owner || "NA"}</div>
                                            <div>Feasibilty Status: <span style={{ color: data?.FeasibilityStatus === "0" ? "red" : data?.FeasibilityStatus === "1" ? "green" : "black" }}> {data?.FeasibilityStatus == '1' ? 'Feasible' : '' || ""}</span></div>
                                            <div>ARC: {data?.Arc || "NA"}</div>
                                            <div>OTC: {data?.Otc || "NA"}</div>
                                            <div>ISP Name: {data?.IspName || "NA"}</div>
                                        </div>
                                    )) : <div>No Feasibility records found.</div>}
                                </div>
                            </div>)}



                        <div className=" text-center mt-5 mb-3">
                            <button
                                type="button"
                                className="btn text-light submit-btn bg-dark mx-auto rounded-pill"
                                onClick={handleUpdateOpportunity}
                                disabled={opportunityData.Status == "Won"}
                            >
                                Update
                            </button>
                        </div>

                    </div>
                </form>
            )}
        </>
    );
};

export default BusinessOpportunityForm;
